
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("73TCo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");





var $bqcqm = parcelRequire("bqcqm");


var $5wpiR = parcelRequire("5wpiR");


var $jmjWc = parcelRequire("jmjWc");


var $7aRa9 = parcelRequire("7aRa9");


const $3dcdb07ca5337b62$var$FloatingAudioContentLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DuuaU",
    name: "FloatingAudioContentLoadable",
    loader: async ()=>(await (parcelRequire("aRdBc"))).FloatingAudioContent
});
const $3dcdb07ca5337b62$export$d559f44428716fef = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const { isOpen: isOpen } = (0, $bqcqm.useAudioPlayerStore)();
    (0, $5wpiR.useAudioPlayerIframeListener)();
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3dcdb07ca5337b62$var$FloatingAudioContentLoadable, {
        flags: flags
    }) : null;
});



var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");








var $bAyaS = parcelRequire("bAyaS");


const $60b070effa9833b5$var$CreateSpaceDrawerLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8t-EL",
    name: "CreateSpaceDrawerLoader",
    loader: async ()=>(await (parcelRequire("hHcm1"))).CreateSpaceDrawer
});
const $60b070effa9833b5$export$8b3b261467ad7423 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [shouldRenderDrawer] = (0, $bAyaS.useShouldRenderDrawer)();
    let t0;
    if ($[0] !== shouldRenderDrawer) {
        t0 = shouldRenderDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($60b070effa9833b5$var$CreateSpaceDrawerLoader, null) : null;
        $[0] = shouldRenderDrawer;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const [shouldRenderDrawer] = (0, $bAyaS.useShouldRenderDrawer)();
    return shouldRenderDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($60b070effa9833b5$var$CreateSpaceDrawerLoader, null) : null;
};



var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");











var $dPJCf = parcelRequire("dPJCf");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");


var $7Ndnw = parcelRequire("7Ndnw");


var $dizL5 = parcelRequire("dizL5");


var $8a9Dm = parcelRequire("8a9Dm");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

const $f8591c817a24c494$var$getError = (messageOrError)=>{
    if (messageOrError instanceof Error) return messageOrError;
    return new Error(messageOrError);
};
const $f8591c817a24c494$export$cf178ec5ae31e0ff = new class ForgeUIExtensionsExperienceTrackerSupport {
    /**
   * Returns true when the event data represents a trackable Forge UI extension instance.
   * Guard this before calling start/succeed/fail/abort.
   */ isTrackable(data) {
        return Boolean(data?.extensionType);
    }
    start(data) {
        (0, $fGzMp.getExperienceTracker)().start({
            name: (0, $irVI7.FORGE_UI_EXTENSIONS_EXPERIENCE),
            attributes: {
                extensionType: data?.extensionType,
                appId: data?.appId
            }
        });
    }
    succeed() {
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: (0, $irVI7.FORGE_UI_EXTENSIONS_EXPERIENCE)
        });
    }
    fail(messageOrError) {
        (0, $fGzMp.getExperienceTracker)().fail({
            name: (0, $irVI7.FORGE_UI_EXTENSIONS_EXPERIENCE),
            error: $f8591c817a24c494$var$getError(messageOrError)
        });
    }
    abort(reason) {
        (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.FORGE_UI_EXTENSIONS_EXPERIENCE),
            reason: reason
        });
    }
}();



var $4vC63 = parcelRequire("4vC63");

const $053fc94f5ddb8d12$export$d15e21537dfa6cb0 = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const experienceStarted = (0, $cozmU.useRef)(false);
    const experienceResolved = (0, $cozmU.useRef)(false);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>()=>{
                if (experienceStarted.current && !experienceResolved.current) (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).abort("ForgeGlobalKeyboardShortcuts unmounted before experience resolved");
            };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[2] !== push) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
            moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
            render: (forgeModules, loading, error)=>{
                if (loading) return null;
                const extensionData = {
                    extensionType: "keyboard-shortcut"
                };
                if (error) {
                    if (!experienceStarted.current && (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).isTrackable(extensionData) && (0, $6mKj3.expVal)("confluence_enable_forge_ui_extensions_metrics", "isEnabled", false)) {
                        (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).start(extensionData);
                        experienceStarted.current = true;
                    }
                    if (experienceStarted.current && !experienceResolved.current) {
                        (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).fail(error);
                        experienceResolved.current = true;
                    }
                    if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                        error: error
                    });
                    return null;
                }
                if (!experienceStarted.current && (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).isTrackable(extensionData) && (0, $6mKj3.expVal)("confluence_enable_forge_ui_extensions_metrics", "isEnabled", false)) {
                    (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).start(extensionData);
                    experienceStarted.current = true;
                }
                if (experienceStarted.current && !experienceResolved.current) {
                    (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).succeed();
                    experienceResolved.current = true;
                }
                return forgeModules.map((module)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
                        key: module.id,
                        module: module,
                        action: ()=>push((0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
                                appId: (0, $8a9Dm.getAppId)(module),
                                envId: module.environmentId,
                                forgeManifestRoute: module.properties.route
                            }))
                    }));
            }
        });
        $[2] = push;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const experienceStarted = (0, $cozmU.useRef)(false);
    const experienceResolved = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (experienceStarted.current && !experienceResolved.current) (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).abort('ForgeGlobalKeyboardShortcuts unmounted before experience resolved');
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
        render: (forgeModules, loading, error)=>{
            if (loading) return null;
            const extensionData = {
                extensionType: 'keyboard-shortcut'
            };
            if (error) {
                if (!experienceStarted.current && (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).isTrackable(extensionData) && (0, $6mKj3.expVal)('confluence_enable_forge_ui_extensions_metrics', 'isEnabled', false)) {
                    (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).start(extensionData);
                    experienceStarted.current = true;
                }
                if (experienceStarted.current && !experienceResolved.current) {
                    (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).fail(error);
                    experienceResolved.current = true;
                }
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
                return null;
            }
            if (!experienceStarted.current && (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).isTrackable(extensionData) && (0, $6mKj3.expVal)('confluence_enable_forge_ui_extensions_metrics', 'isEnabled', false)) {
                (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).start(extensionData);
                experienceStarted.current = true;
            }
            if (experienceStarted.current && !experienceResolved.current) {
                (0, $f8591c817a24c494$export$cf178ec5ae31e0ff).succeed();
                experienceResolved.current = true;
            }
            return forgeModules.map((module)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
                    key: module.id,
                    module: module,
                    action: ()=>push((0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
                            appId: (0, $8a9Dm.getAppId)(module),
                            envId: module.environmentId,
                            forgeManifestRoute: module.properties.route
                        }))
                }));
        }
    });
});


parcelRequire("h3wYQ");
var $cQbTj = parcelRequire("cQbTj");
var $f8AFM = parcelRequire("f8AFM");

parcelRequire("lfopc");
var $l1elF = parcelRequire("l1elF");











const $ceaefb39b3ad51ae$var$FloatingEnterpriseHerContentLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5oeLQ",
    name: "FloatingEnterpriseHerContentLoadable",
    loader: async ()=>(await (parcelRequire("i2el2"))).FloatingEnterpriseHerContent
});
const $ceaefb39b3ad51ae$export$2ae52161c1f11a14 = ()=>{
    if (!(0, $6mKj3.expVal)('enterprise_her', 'isEnabled', false)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceaefb39b3ad51ae$var$FloatingEnterpriseHerContentLoadable, null);
};



var $hAnPj = parcelRequire("hAnPj");











var $alLTz = parcelRequire("alLTz");


const $3729a951937314e9$var$StorageEnforcementFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_U9ss",
    name: "StorageEnforcementFlagsLoadable",
    loader: async ()=>(await (parcelRequire("hGf3w"))).StorageEnforcementFlags
});
const $3729a951937314e9$export$8df08a490eb32a33 = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3729a951937314e9$var$StorageEnforcementFlagsLoadable, null) : null;
};












const $372cb008daefafdd$var$GracePeriodModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "6zo21",
    name: "GracePeriodModalLoadable",
    loader: async ()=>(await (parcelRequire("e5nB1"))).GracePeriodModalErrorBoundary
});
const $372cb008daefafdd$export$38134b9c38b2723c = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($372cb008daefafdd$var$GracePeriodModalLoadable, null) : null;
};












const $2c6a471f2dd5d9be$var$BlockCreateModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Mxabm",
    name: "BlockCreateModalLoadable",
    loader: async ()=>(await (parcelRequire("dNNUs"))).BlockCreateModal
});
const $2c6a471f2dd5d9be$export$4bd1fbb328f3ee8b = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c6a471f2dd5d9be$var$BlockCreateModalLoadable, null) : null;
};


const $7ac3d7089b8f08ca$export$5bf713f6291006b2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3729a951937314e9$export$8df08a490eb32a33), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $372cb008daefafdd$export$38134b9c38b2723c), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c6a471f2dd5d9be$export$4bd1fbb328f3ee8b), null));
};















const $0df0146ac7c3c72f$var$ConnectorDeepLinkLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "m-hbs",
    name: "ConnectorDeepLinkLoadable",
    loader: async ()=>(await (parcelRequire("kqYDv"))).ConnectorDeepLink
});
const $0df0146ac7c3c72f$export$7778259db8569cee = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).AI_MATE,
        attributes: {
            errorBoundaryId: 'GlobalComponents-ConnectorDeepLink'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0df0146ac7c3c72f$var$ConnectorDeepLinkLoadable, null));
};









var $kSwu1 = parcelRequire("kSwu1");


var $a33Aa = parcelRequire("a33Aa");


var $hdBxM = parcelRequire("hdBxM");


var $7NHN3 = parcelRequire("7NHN3");


var $beNrf = parcelRequire("beNrf");


var $93Gae = parcelRequire("93Gae");

/**
 * Post Office message template ID for the reintroduction modal. Post Office owns
 * audience targeting, dismissal, and fatigue for this template; the launcher
 * shows the modal whenever a message is returned for it.
 *
 * TODO: confirm the template ID registered in Post Office before rollout.
 */ const $765d32199776aa63$export$6c9deb1363deebc3 = 'rovo-reintroduction-modal';
const $765d32199776aa63$export$2e1b04d234dadc5a = 'ai-mate';
const $765d32199776aa63$export$6502e013b67617c2 = 'rovo-reintroduction-modal';


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $hekY6 = parcelRequire("hekY6");





var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");


var $I7hWB = parcelRequire("I7hWB");


var $eDtFr = parcelRequire("eDtFr");


var $bltJZ = parcelRequire("bltJZ");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $lQXDC = parcelRequire("lQXDC");

var $6htAj = parcelRequire("6htAj");

var $jYwtP = parcelRequire("jYwtP");




const $faee27bbfc8c0c71$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "rovo-reintroduction-modal.title",
        defaultMessage: "Allow me to reintroduce myself."
    },
    body: {
        id: "rovo-reintroduction-modal.body",
        defaultMessage: "I\u2019ve been busy learning new tricks. With 300+ new tools in Jira and Confluence, I can now take action across your entire workflow. I\u2019ve also added deeper reasoning for complex problems, a personal memory to stay in sync with you, and the combined intelligence of Google, OpenAI, and Anthropic."
    },
    primaryAction: {
        id: "rovo-reintroduction-modal.primary-action",
        defaultMessage: "Tell me how to improve my workflow with Rovo"
    },
    chatPreviewPrompt: {
        id: "rovo-reintroduction-modal.chat-preview-prompt",
        defaultMessage: "What do you want to do next?"
    }
});


/* prompt-box-video.tsx generated by @compiled/babel-plugin v2.0.0 */ 









const $cd47a1d95fd2f020$var$REINTRO_VIDEO_SRC = 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OAWR.mp4'; /**
                                                                                       * Must match `HERO_BACKGROUND_COLOR` in the modal: the gradient fades the video's
                                                                                       * left edge into the hero background. Kept as a local copy because
                                                                                       * `@atlaskit/ui-styling-standard` forbids importing values used inside `cssMap`.
                                                                                       */ 
const $cd47a1d95fd2f020$var$HERO_BACKGROUND_COLOR = '#F8F8F8';
const $cd47a1d95fd2f020$var$styles = {
    container: "_1mT5xdWVPG _4ApkO2dnbC _0Bm75GdnbC _42Yu6B7dHp _1VJPcaD1I3 _39xV028h1t _3v5uP02ByS",
    video: "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _00EA0egIor",
    blend: "_1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _3iC0zddnbC _39xV028i9X _1pp6NdYbGa _3CkH9oKEVi"
}; /**
    * Decorative, looping video of the Rovo prompt box shown in the hero of the
    * modal. Autoplays muted so it can start without user interaction. Positioned
    * absolutely, so it must be rendered inside a `position: relative` container.
    *
    * The video src is intentionally set after mount (via useEffect) to prevent the
    * browser from fetching the MP4 during the host page's initial load. Without
    * this deferral, autoPlay causes an eager network request that competes with
    * page assets and inflates VC90 p90 (Confluence Live Doc) in Statsig.
    */ 
function $cd47a1d95fd2f020$export$864873273c2df90a() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const videoRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (videoRef.current) videoRef.current.src = $cd47a1d95fd2f020$var$REINTRO_VIDEO_SRC;
    }, []);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $cd47a1d95fd2f020$var$styles.container
        ])
    }, /*#__PURE__*/ $cozmU.createElement("video", {
        ref: videoRef,
        autoPlay: true,
        loop: true,
        muted: true,
        playsInline: true,
        "aria-label": formatMessage((0, $faee27bbfc8c0c71$export$defe85febe8b728c).chatPreviewPrompt),
        className: (0, $hekY6.default)([
            $cd47a1d95fd2f020$var$styles.video
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $cd47a1d95fd2f020$var$styles.blend
        ])
    }));
}


const $7da2c34dfa11ff8f$var$SOURCE_NAME = 'rovoReintroductionModal'; /**
                                                * Background colour of the hero container. Matches the prompt-box video clip's
                                                * baked-in background (#F8F8F8) so the two read as a single surface. Defined
                                                * locally because `@atlaskit/ui-styling-standard` forbids importing values used
                                                * inside `cssMap`; the prompt-box video keeps its own matching copy.
                                                */ 
const $7da2c34dfa11ff8f$var$HERO_BACKGROUND_COLOR = '#F8F8F8';
const $7da2c34dfa11ff8f$var$styles = {
    hero: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _1mT5xdRAKS _3iDTPbgBM8 _2iEGP2Lmr7 _0hPCNLFlnN _17lj8pNHnM _4kiQYABfNa _0KLXruufgJ",
    patternVertical: "_1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _3iC0zddnbC _1OKFqYdnbC _42Yu6BdnbC _1pp6NdYbGa _3CkH9oBE3o _3OqcjTPyPJ _3X9j4qj2cV",
    patternHorizontal: "_1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _3iC0zddnbC _1OKFqYdnbC _42Yu6BdnbC _1pp6NdYbGa _3CkH9oBE3o _3OqcjTzPbG _3X9j4qj2cV",
    heroTextColumn: "_2mHwu8Va5s _1mT5xdRAKS _42Yu6B7dHp _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuI7V3 _0Of8r2S40j _1ZnuxbS40j _1wydGWS40j _2Zuz6QS40j",
    body: "_0Of8r2NHnM _1wydGW2ADO"
};
function $7da2c34dfa11ff8f$export$de27a1fdb877159c({ analyticsAttributes: analyticsAttributes, onClickPrimary: onClickPrimary, onClose: onClose, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handlePrimaryClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoReintroductionModalPrimary'
        }).fire('atlaskit');
        onClickPrimary();
    }, [
        createAnalyticsEvent,
        onClickPrimary
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoReintroductionModalClose'
        }).fire('atlaskit');
        onClose();
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $lQXDC.ContextWrapper), {
        sourceName: $7da2c34dfa11ff8f$var$SOURCE_NAME,
        sourceType: (0, $jYwtP.MODAL),
        attributes: analyticsAttributes
    }, /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        width: "large",
        onClose: handleClose,
        testId: testId,
        label: formatMessage((0, $faee27bbfc8c0c71$export$defe85febe8b728c).title)
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $7da2c34dfa11ff8f$var$styles.hero
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $7da2c34dfa11ff8f$var$styles.patternVertical
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $7da2c34dfa11ff8f$var$styles.patternHorizontal
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $7da2c34dfa11ff8f$var$styles.heroTextColumn
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xlarge",
        as: "h2"
    }, formatMessage((0, $faee27bbfc8c0c71$export$defe85febe8b728c).title)), /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoLogo), null)), /*#__PURE__*/ $cozmU.createElement((0, $cd47a1d95fd2f020$export$864873273c2df90a), null)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $7da2c34dfa11ff8f$var$styles.body
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium"
    }, formatMessage((0, $faee27bbfc8c0c71$export$defe85febe8b728c).body)))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
        onClick: handlePrimaryClick
    }, formatMessage((0, $faee27bbfc8c0c71$export$defe85febe8b728c).primaryAction))), /*#__PURE__*/ $cozmU.createElement((0, $6htAj.FireScreenAnalytics), null)));
}





const $2237da2c855316a4$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    chatPrompt: {
        id: "rovo-reintroduction-modal.chat-prompt",
        defaultMessage: "Tell me how to improve my workflow with Rovo"
    }
});


/**
 * Query param used by the dev-only override below.
 */ const $cc534de3a8100458$var$DEV_FORCE_OPEN_PARAM = 'forceRovoReintroductionModal';
/**
 * Module-level set that tracks dismissed message instance IDs for the lifetime
 * of the browser session. This survives SPA navigations (component
 * unmount/remount) so the modal won't re-appear on subsequent pages after the
 * user has dismissed it — even if the headless cache still contains the stale
 * messageInstanceId. On a full page refresh the Set is cleared, but by then the
 * server has already recorded the dismissal so useMessageInstances won't return
 * a messageInstanceId anyway.
 */ const $cc534de3a8100458$var$dismissedInstanceIds = new Set();
/**
 * Dev-only escape hatch for manual testing: append
 * `?forceRovoReintroductionModal=true` to the URL to force the modal open,
 * bypassing the experiment, Post Office eligibility, and the Rovo-chat-open
 * check.
 *
 * Honored ONLY outside production builds (`process.env.NODE_ENV !== 'production'`),
 * so it can never bypass those checks for shipped users — even if the param
 * happens to be present on a production URL.
 */ function $cc534de3a8100458$var$isDevForceOpen() {
    return false;
}
function $cc534de3a8100458$export$435ca743db9c77a3(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cc534de3a8100458$var$RovoReintroductionLauncherInner, props);
}
function $cc534de3a8100458$var$RovoReintroductionLauncherInner({ product: product, openChatMode: openChatMode = 'sidebar', prompt: prompt, testId: testId }) {
    const devForceOpen = $cc534de3a8100458$var$isDevForceOpen();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(devForceOpen);
    const { mode: mode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const publishRovo = (0, $hdBxM.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Post Office owns eligibility, dismissal, and fatigue. Presence of a message
    // for this template means the user is eligible to be shown the modal.
    // `PostOfficeMessage` is the wrapper that fires Post Office's impression
    // ("viewed") lifecycle when the modal actually renders.
    const { messages: postOfficeMessages, PostOfficeMessageInstance: PostOfficeMessageInstance, dismissMessage: dismissMessage } = (0, $beNrf.useMessageInstances)({
        placementId: 'headless',
        messageTemplateId: (0, $765d32199776aa63$export$6c9deb1363deebc3)
    });
    const message = postOfficeMessages?.[0];
    const messageInstanceId = message?.messageInstanceId;
    // A Rovo chat is already open in this session. Used as a pre-render guard
    // below (after the Post Office eligibility check) so the reintroduction modal
    // never stacks on top of an open chat.
    const isChatOpen = mode !== undefined;
    // Open at most once per mount, after Post Office confirms an eligible message.
    // The experiment (and its exposure event) is resolved only once a message is
    // available and no chat is open, so the Statsig exposure fires exclusively for
    // users we could actually show the modal to.
    const hasOpenedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (devForceOpen || hasOpenedRef.current || !messageInstanceId || isChatOpen || $cc534de3a8100458$var$dismissedInstanceIds.has(messageInstanceId)) return;
        hasOpenedRef.current = true;
        setIsOpen(true);
    }, [
        devForceOpen,
        messageInstanceId,
        isChatOpen
    ]);
    const handleOpenChat = (0, $cozmU.useCallback)(()=>{
        publishRovo({
            type: 'chat-new',
            source: (0, $765d32199776aa63$export$6502e013b67617c2),
            openChat: true,
            openChatMode: openChatMode,
            data: {
                dialogues: [],
                prompt: prompt ?? formatMessage((0, $2237da2c855316a4$export$defe85febe8b728c).chatPrompt)
            }
        });
        if (messageInstanceId) {
            $cc534de3a8100458$var$dismissedInstanceIds.add(messageInstanceId);
            dismissMessage(messageInstanceId);
        }
        setIsOpen(false);
    }, [
        dismissMessage,
        formatMessage,
        messageInstanceId,
        openChatMode,
        prompt,
        publishRovo
    ]);
    // ✅ ADD — client-side only: close modal
    const handleClientClose = (0, $cozmU.useCallback)(()=>{
        if (messageInstanceId) {
            $cc534de3a8100458$var$dismissedInstanceIds.add(messageInstanceId);
            dismissMessage(messageInstanceId);
        }
        setIsOpen(false);
    }, [
        dismissMessage,
        messageInstanceId
    ]);
    if (!isOpen || !PostOfficeMessageInstance || !messageInstanceId) return null;
    // Pre-render guard (after the Post Office eligibility check): never render on
    // top of an already-open Rovo chat.
    if (isChatOpen) return null;
    // Render through the Post Office message wrapper so the impression lifecycle
    // (Post Office "viewed" events + the modal's own `FireScreenAnalytics`) fires
    // only when the choreographer allows the message to show.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PostOfficeMessageInstance, {
        messageInstanceId: messageInstanceId
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cc534de3a8100458$var$RovoReintroductionModalWithDismiss, {
            analyticsAttributes: {
                product: product
            },
            onOpenChat: handleOpenChat,
            onClose: handleClientClose,
            testId: testId
        }));
}
/**
 * Inner wrapper rendered inside PostOfficeMessageInstance so that
 * useMessageInstanceEvent has access to the Post Office provider context.
 * This is required for the dismiss network request to actually fire.
 */ function $cc534de3a8100458$var$RovoReintroductionModalWithDismiss({ analyticsAttributes: analyticsAttributes, onOpenChat: onOpenChat, onClose: onClose, testId: testId }) {
    const { messageInstanceClicked: messageInstanceClicked } = (0, $7NHN3.useMessageInstanceEvent)();
    // This component mounts only once the choreographer actually shows the message, so
    // the modal is on screen from here on. Abort any in-flight UFO interaction so the
    // overlay is not measured as part of the underlying page's visible content.
    (0, $cozmU.useEffect)(()=>{
        (0, $a33Aa.abortAll)('new_interaction', 'rovo-reintroduction-modal');
    }, []);
    const fireDismissEvent = (0, $cozmU.useCallback)(()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss-rovo-reintroduction',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
    }, [
        messageInstanceClicked
    ]);
    const handleClickPrimary = (0, $cozmU.useCallback)(()=>{
        fireDismissEvent();
        onOpenChat();
    }, [
        fireDismissEvent,
        onOpenChat
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        fireDismissEvent();
        onClose();
    }, [
        fireDismissEvent,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7da2c34dfa11ff8f$export$de27a1fdb877159c), {
        analyticsAttributes: analyticsAttributes,
        onClickPrimary: handleClickPrimary,
        onClose: handleClose,
        testId: testId
    });
}









var $i3jcY = parcelRequire("i3jcY");



// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $8AKrx = parcelRequire("8AKrx");


var $4S8ti = parcelRequire("4S8ti");



const $fcf149ef3fc7ff73$export$99c76ad477e76512 = ()=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_PUMA,
        attributes: {
            errorBoundaryId: 'GlobalComponents-GrowthPuma'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4S8ti.CrossJoinNudgesWithFlags), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).AI_MATE,
        attributes: {
            errorBoundaryId: 'GlobalComponents-RovoReintroduction'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cc534de3a8100458$export$435ca743db9c77a3), {
        product: "confluence"
    })));
};


















var $9wGTI = parcelRequire("9wGTI");




// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 






const $63d46b1fc54f0401$var$NthUserOrientationLoadable = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pjDSS",
    name: "NthUserOrientationLoadable",
    loader: async ()=>(await (parcelRequire("7KWaT"))).NthUserOrientation
});
const $63d46b1fc54f0401$export$11a38f66cbb85629 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63d46b1fc54f0401$var$NthUserOrientationLoadable, null);
};



const $a62f4f3e55485b0c$var$RovoAnnouncementSplashModalLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Gg8Jr",
    name: "RovoAnnouncementSplashModalLoadable",
    loader: async ()=>(await (parcelRequire("hUiLd"))).RovoAnnouncementSplashModal
});

const $a62f4f3e55485b0c$var$ConnectorSetupModalHostLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8ahUG",
    name: "ConnectorSetupModalHostLoadable",
    loader: async ()=>(await (parcelRequire("jiQoC"))).ConnectorSetupModalHost
});
const $a62f4f3e55485b0c$export$d440a40388af1c12 = ()=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CE_MAU
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63d46b1fc54f0401$export$11a38f66cbb85629), null)), (0, $9wGTI.fg)('aifc_onboarding_ga_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_FEATURE_DISCOVERY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a62f4f3e55485b0c$var$RovoAnnouncementSplashModalLoadable, null)), (0, $6mKj3.UNSAFE_expValNoExposure)('twcg-1489-cc-3p-connector-onboarding', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_CFIND
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a62f4f3e55485b0c$var$ConnectorSetupModalHostLoadable, null)));
};















const $363c2f84aa85fa56$var$SmartCreationModalLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Sb6aM",
    name: "SmartCreationModalLoadable",
    loader: async ()=>(await (parcelRequire("4DHPP"))).ConfluenceSmartCreationModalLoader
});
const $363c2f84aa85fa56$export$fa257c3858869fed = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Smarts'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($363c2f84aa85fa56$var$SmartCreationModalLoadable, null));
};



























var $euL71 = parcelRequire("euL71");


var $fcF01 = parcelRequire("fcF01");


const $8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "z7feK",
    name: "LazyExperimentPlanSelectionModal",
    loader: async ()=>(await (parcelRequire("csHE2"))).ExperimentPlanSelectionModal
});
const $8e4a487f1ccf39b0$export$7699251dbf86d265 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { currentEdition: currentEdition } = (0, $cozmU.useContext)((0, $fcF01.UpFlowContext));
    let t0;
    if ($[0] !== currentEdition) {
        t0 = currentEdition === (0, $euL71.ConfluenceEdition).FREE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal, null);
        $[0] = currentEdition;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { currentEdition: currentEdition } = (0, $cozmU.useContext)((0, $fcF01.UpFlowContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, currentEdition === (0, $euL71.ConfluenceEdition).FREE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal, null));
};






var $aJv6Q = parcelRequire("aJv6Q");








const $f7a2cd2323bccfe9$var$TrialFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uEpNB",
    name: "TrialFlagsLoadable",
    loader: async ()=>(await (parcelRequire("kdqYf"))).TrialFlags
});
const $f7a2cd2323bccfe9$export$c108f21945b8b79 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).GROWTH_LUNA
})(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7a2cd2323bccfe9$var$TrialFlagsLoadable, null));


const $869a3ecc023117fa$export$7e65e5c9acad9939 = ()=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
        attributes: {
            errorBoundaryId: 'GlobalComponents-GrowthLuna'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8e4a487f1ccf39b0$export$7699251dbf86d265), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7a2cd2323bccfe9$export$c108f21945b8b79), null));
};


const $21316eb17a577fc6$export$461c2ed3163c74ff = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Disco'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $60b070effa9833b5$export$8b3b261467ad7423), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $363c2f84aa85fa56$export$fa257c3858869fed), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CC_IMPORTER,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Importer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8AFM.ConditionalImportContentModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cQbTj.ConditionalImportContentDrawer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1elF.ConditionalSingleImportModal), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Ecosystem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $053fc94f5ddb8d12$export$d15e21537dfa6cb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE,
        attributes: {
            errorBoundaryId: 'GlobalComponents-AdminExperience'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ac3d7089b8f08ca$export$5bf713f6291006b2), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $869a3ecc023117fa$export$7e65e5c9acad9939), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hAnPj.LazyRestrictionsDialogMountPoint), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a62f4f3e55485b0c$export$d440a40388af1c12), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fcf149ef3fc7ff73$export$99c76ad477e76512), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0df0146ac7c3c72f$export$7778259db8569cee), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Audio'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3dcdb07ca5337b62$export$d559f44428716fef), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS,
        attributes: {
            errorBoundaryId: 'GlobalComponents-HER'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ceaefb39b3ad51ae$export$2ae52161c1f11a14), null)));
};
module.exports["GlobalComponents"] = $21316eb17a577fc6$export$461c2ed3163c74ff;

});

parcelRegister("5wpiR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bqcqm = parcelRequire("bqcqm");

const $563e5cf7d905ecff$export$c4a6bbd66a3ec4f3 = 'AUDIO_PLAYER_OPEN_REQUEST';
const $563e5cf7d905ecff$var$isAudioPlayerIframeMessage = (data)=>{
    if (!data || typeof data !== 'object') return false;
    const message = data;
    return message.type === $563e5cf7d905ecff$export$c4a6bbd66a3ec4f3 && message.activeContent != null;
};
const $563e5cf7d905ecff$export$ce895abfddbf56a4 = ()=>{
    const { openAudioPlayer: openAudioPlayer } = (0, $bqcqm.useAudioPlayerStore)();
    (0, $cozmU.useEffect)(()=>{
        const handleMessage = (event)=>{
            if (!$563e5cf7d905ecff$var$isAudioPlayerIframeMessage(event.data)) return;
            openAudioPlayer(event.data.activeContent, event.data.options);
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        openAudioPlayer
    ]);
};
module.exports["AUDIO_PLAYER_OPEN_REQUEST"] = $563e5cf7d905ecff$export$c4a6bbd66a3ec4f3;
module.exports["useAudioPlayerIframeListener"] = $563e5cf7d905ecff$export$ce895abfddbf56a4;

});

parcelRegister("aRdBc", function(module, exports) {

let $7e79671be2be37ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7e79671be2be37ea$var$load("7wlV6"),
    $7e79671be2be37ea$var$load("g0T7B"),
    $7e79671be2be37ea$var$load("1VQii"),
    $7e79671be2be37ea$var$load("3gMot"),
    $7e79671be2be37ea$var$load("hEj0j"),
    $7e79671be2be37ea$var$load("j6yAY"),
    $7e79671be2be37ea$var$load("flgjz"),
    $7e79671be2be37ea$var$load("2c6JK"),
    $7e79671be2be37ea$var$load("lFmKr"),
    $7e79671be2be37ea$var$load("jtCPF"),
    $7e79671be2be37ea$var$load("j6C9F"),
    $7e79671be2be37ea$var$load("8vGrd"),
    $7e79671be2be37ea$var$load("blCE0"),
    $7e79671be2be37ea$var$load("7oAXW"),
    $7e79671be2be37ea$var$load("32NHR"),
    $7e79671be2be37ea$var$load("glmO2"),
    $7e79671be2be37ea$var$load("cmmpX"),
    $7e79671be2be37ea$var$load("4bzNN"),
    $7e79671be2be37ea$var$load("4zGQj"),
    $7e79671be2be37ea$var$load("hAlZp"),
    $7e79671be2be37ea$var$load("kHXvF"),
    $7e79671be2be37ea$var$load("6wr18"),
    $7e79671be2be37ea$var$load("7gL7H"),
    $7e79671be2be37ea$var$load("ea3NB"),
    $7e79671be2be37ea$var$load("kQrFf"),
    $7e79671be2be37ea$var$load("gDSsc"),
    $7e79671be2be37ea$var$load("exBMi"),
    $7e79671be2be37ea$var$load("iBJWz"),
    $7e79671be2be37ea$var$load("ffEVr"),
    $7e79671be2be37ea$var$load("80Yra"),
    $7e79671be2be37ea$var$load("35Mi3"),
    $7e79671be2be37ea$var$load("hhss7"),
    $7e79671be2be37ea$var$load("Wowvf"),
    $7e79671be2be37ea$var$load("uvm9i"),
    $7e79671be2be37ea$var$load("vsgOr"),
    $7e79671be2be37ea$var$load("i313S"),
    $7e79671be2be37ea$var$load("7EorR"),
    $7e79671be2be37ea$var$load("3WaAl")
]).then(()=>parcelRequire('iLFiU'));

});

parcelRegister("bAyaS", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $8eabddf4fe78ba91$var$initialState = {
    showCreateSpaceDrawer: false,
    shouldRenderDrawer: false,
    createSpaceButtonRef: {
        current: null
    },
    createSpaceButtonLocation: undefined
};
const $8eabddf4fe78ba91$export$e324594224ef24da = {
    openDrawer: (value, createSpaceButtonLocation)=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: true,
                shouldRenderDrawer: true,
                createSpaceButtonRef: value,
                createSpaceButtonLocation: createSpaceButtonLocation
            });
        },
    closeDrawer: ()=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: false,
                createSpaceButtonLocation: undefined
            });
        }
};
const $8eabddf4fe78ba91$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $8eabddf4fe78ba91$var$initialState,
    actions: $8eabddf4fe78ba91$export$e324594224ef24da,
    name: 'createSpaceStore'
});
const $8eabddf4fe78ba91$export$5642c413017336a4 = (0, $kBr4q.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
const $8eabddf4fe78ba91$var$getShouldRenderDrawer = (state)=>{
    return state.shouldRenderDrawer;
};
const $8eabddf4fe78ba91$export$34596812152477bc = (0, $kBr4q.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getShouldRenderDrawer
});
const $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing = (state)=>{
    return state.showCreateSpaceDrawer;
};
const $8eabddf4fe78ba91$export$5ff6e7335b182a8e = (0, $kBr4q.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing
});
const $8eabddf4fe78ba91$export$ad3d638eaaafd693 = (0, $kBr4q.createActionsHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
module.exports["useCreateSpaceStore"] = $8eabddf4fe78ba91$export$5642c413017336a4;
module.exports["useShouldRenderDrawer"] = $8eabddf4fe78ba91$export$34596812152477bc;
module.exports["useCreateSpaceStoreActions"] = $8eabddf4fe78ba91$export$ad3d638eaaafd693;

});

parcelRegister("hHcm1", function(module, exports) {

let $ce20091aa8bbd22b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ce20091aa8bbd22b$var$load("vsgOr"),
    $ce20091aa8bbd22b$var$load("i313S"),
    $ce20091aa8bbd22b$var$load("6OMo6"),
    $ce20091aa8bbd22b$var$load("aaRXj"),
    $ce20091aa8bbd22b$var$load("fHlIz"),
    $ce20091aa8bbd22b$var$load("4QwAJ"),
    $ce20091aa8bbd22b$var$load("3i44s"),
    $ce20091aa8bbd22b$var$load("5kI0b"),
    $ce20091aa8bbd22b$var$load("kYkz1"),
    $ce20091aa8bbd22b$var$load("jfYeU"),
    $ce20091aa8bbd22b$var$load("b4nm1"),
    $ce20091aa8bbd22b$var$load("geXPZ"),
    $ce20091aa8bbd22b$var$load("aQ5uu"),
    $ce20091aa8bbd22b$var$load("6wr18"),
    $ce20091aa8bbd22b$var$load("ehQBw"),
    $ce20091aa8bbd22b$var$load("amPsT"),
    $ce20091aa8bbd22b$var$load("gW7tk"),
    $ce20091aa8bbd22b$var$load("fYEgh"),
    $ce20091aa8bbd22b$var$load("hOaAV"),
    $ce20091aa8bbd22b$var$load("6XCf4"),
    $ce20091aa8bbd22b$var$load("fINdN"),
    $ce20091aa8bbd22b$var$load("i0Zk0"),
    $ce20091aa8bbd22b$var$load("lVz4k"),
    $ce20091aa8bbd22b$var$load("aEiTV"),
    $ce20091aa8bbd22b$var$load("1qlDN"),
    $ce20091aa8bbd22b$var$load("1yVM6"),
    $ce20091aa8bbd22b$var$load("iWnyc"),
    $ce20091aa8bbd22b$var$load("dq8fV"),
    $ce20091aa8bbd22b$var$load("ffEVr"),
    $ce20091aa8bbd22b$var$load("hhss7"),
    $ce20091aa8bbd22b$var$load("Wowvf"),
    $ce20091aa8bbd22b$var$load("uvm9i"),
    $ce20091aa8bbd22b$var$load("7EorR"),
    $ce20091aa8bbd22b$var$load("atyNV")
]).then(()=>parcelRequire('1tDKi'));

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("k8tAC"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("k8tAC", function(module, exports) {

let $ea8b81dc74353d2a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ea8b81dc74353d2a$var$load("feGHs"),
    $ea8b81dc74353d2a$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("4vC63", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { module: module, tooltip: t1, children: children } = t0;
    const tooltip = t1 === undefined ? "" : t1;
    let accelerator;
    let t2;
    if ($[0] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t2 = accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = module;
        $[1] = accelerator;
        $[2] = t2;
    } else {
        accelerator = $[1];
        t2 = $[2];
    }
    if (t2) {
        const t3 = `forge-keyboard-shortcut-visualizer-${accelerator}`;
        let t4;
        if ($[3] !== accelerator || $[4] !== tooltip) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: accelerator,
                contentBefore: tooltip,
                isTooltip: true
            });
            $[3] = accelerator;
            $[4] = tooltip;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== children || $[7] !== t3 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                tag: "span",
                testId: t3,
                content: t4
            }, children);
            $[6] = children;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    let t3;
    if ($[10] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[10] = children;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { module: module, action: action } = t0;
    let accelerator;
    let t1;
    if ($[0] !== action || $[1] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t1 = accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = action;
        $[1] = module;
        $[2] = accelerator;
        $[3] = t1;
    } else {
        accelerator = $[2];
        t1 = $[3];
    }
    if (t1) {
        const t2 = `forge-keyboard-shortcut-${accelerator}`;
        let t3;
        if ($[4] !== accelerator || $[5] !== action) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
                accelerator: accelerator,
                listener: action,
                shortcutType: (0, $bflGB.ShortcutType).Forge
            });
            $[4] = accelerator;
            $[5] = action;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "data-testid": t2
            }, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    return null;
} : ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("h3wYQ", function(module, exports) {
$parcel$export(module.exports, "ConditionalImportContentDrawer", () => (parcelRequire("cQbTj")).ConditionalImportContentDrawer);
$parcel$export(module.exports, "ConditionalImportContentModal", () => (parcelRequire("f8AFM")).ConditionalImportContentModal);
$parcel$export(module.exports, "ImportContentButton", () => (parcelRequire("gKGjM")).ImportContentButton);
$parcel$export(module.exports, "useImportContentStoreActions", () => (parcelRequire("5IN3L")).useImportContentStoreActions);

var $cQbTj = parcelRequire("cQbTj");


var $f8AFM = parcelRequire("f8AFM");


var $gKGjM = parcelRequire("gKGjM");


var $5IN3L = parcelRequire("5IN3L");


});

parcelRegister("cQbTj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $5IN3L = parcelRequire("5IN3L");


const $8584efcc44eb8061$var$ImportContentDrawerLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "R258E",
    name: "ImportContentDrawerLoader",
    loader: async ()=>(await (parcelRequire("1DOZQ"))).ImportContentDrawer
});
const $8584efcc44eb8061$export$5aeeed7cf265bb36 = ()=>{
    const [importContentState, importContentActions] = (0, $5IN3L.useImportContentStore)();
    return importContentState.shouldRenderDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8584efcc44eb8061$var$ImportContentDrawerLoader, {
        isImportingContent: importContentState.showImportContentDrawer,
        setIsImportingContent: importContentActions.setShowImportContentDrawer,
        contentType: importContentState.contentType
    }) : null;
};
module.exports["ConditionalImportContentDrawer"] = $8584efcc44eb8061$export$5aeeed7cf265bb36;

});

parcelRegister("5IN3L", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cozmU = parcelRequire("cozmU");


var $8uc8a = parcelRequire("8uc8a");


var $27ffu = parcelRequire("27ffu");


var $dzqet = parcelRequire("dzqet");

const $c73c161a517b87e3$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: {
        showImportContentDrawer: false,
        shouldRenderDrawer: false,
        showImportContentModal: false,
        shouldRenderModal: false,
        shouldRenderMiroTokenModal: false,
        contentType: (0, $dzqet.ContentType).NOTION
    },
    actions: {
        setShowImportContentDrawer: (value)=>({ setState: setState })=>{
                setState({
                    showImportContentDrawer: value
                });
            },
        setShouldRenderDrawer: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderDrawer: value
                });
            },
        setShowImportContentModal: (value)=>({ setState: setState })=>{
                setState({
                    showImportContentModal: value
                });
            },
        setShouldRenderModal: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderModal: value
                });
            },
        setShouldRenderMiroTokenModal: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderMiroTokenModal: value
                });
            },
        setContentType: (value)=>({ setState: setState })=>{
                setState({
                    contentType: value
                });
            }
    },
    name: 'importContentStore'
});
const $c73c161a517b87e3$export$7805c3dc7bda328d = /*#__PURE__*/ (0, $cozmU.createContext)({
    authProviderError: '',
    setAuthProviderError: ()=>{},
    hasSubpages: false,
    setHasSubpages: ()=>{},
    dropzoneCancelFnRef: {
        current: null
    },
    browserCancelFnRef: {
        current: null
    },
    isUploadingFile: false,
    setIsUploadingFile: ()=>{},
    isStartingImport: false,
    setIsStartingImport: ()=>{},
    fileNameDisplay: '',
    setFileNameDisplay: ()=>{},
    fileSizeBytes: 0,
    setFileSizeBytes: ()=>{},
    filestoreId: '',
    setFilestoreId: ()=>{},
    migrationScopeId: '',
    setMigrationScopeId: ()=>{},
    migrationId: '',
    setMigrationId: ()=>{},
    collectionId: '',
    setCollectionId: ()=>{},
    shouldMapNotionMembers: true,
    setShouldMapNotionMembers: ()=>{},
    shouldRenderCloseDrawerModal: false,
    setShouldRenderCloseDrawerModal: ()=>{},
    shouldRenderIntegrationTokenModal: false,
    setShouldRenderIntegrationTokenModal: ()=>{},
    integrationToken: '',
    setIntegrationToken: ()=>{},
    shouldAddRemainingMembers: false,
    setShouldAddRemainingMembers: ()=>{},
    shouldCopyPagePermissions: false,
    setShouldCopyPagePermissions: ()=>{},
    shouldRenderAccessTokenModal: false,
    setShouldRenderAccessTokenModal: ()=>{},
    shouldExportEntities: true,
    setShouldExportEntities: ()=>{},
    accessToken: '',
    setAccessToken: ()=>{},
    refreshToken: '',
    setRefreshToken: ()=>{},
    tokenExpireAt: '',
    setTokenExpireAt: ()=>{},
    newSpaceName: '',
    setNewSpaceName: ()=>{},
    setExistingSpace: ()=>{},
    setParentPageId: ()=>{},
    selectedPermissions: (0, $8uc8a.PermissionOptions).DEFAULT,
    setSelectedPermissions: ()=>{},
    miroAuthToken: '',
    setMiroAuthToken: ()=>{},
    miroTeamId: '',
    setMiroTeamId: ()=>{},
    miroProjectId: null,
    setMiroProjectId: ()=>{},
    clearAllMiroBulkImportTokens: ()=>{},
    didReceiveMiroBulkApiTokens: false,
    setDidReceiveMiroBulkApiTokens: ()=>{},
    isNotionWorkspaceImportDisabled: false,
    setIsNotionWorkspaceImportDisabled: ()=>{},
    isValidatingZip: false,
    setIsValidatingZip: ()=>{}
});
const $c73c161a517b87e3$export$4261666d8e0efef2 = (props)=>{
    const [authProviderError, setAuthProviderError] = (0, $cozmU.useState)('');
    const [hasSubpages, setHasSubpages] = (0, $cozmU.useState)(false);
    const dropzoneCancelFnRef = (0, $cozmU.useRef)(null);
    const browserCancelFnRef = (0, $cozmU.useRef)(null);
    const [isUploadingFile, setIsUploadingFile] = (0, $cozmU.useState)(false);
    const [isStartingImport, setIsStartingImport] = (0, $cozmU.useState)(false);
    const [fileNameDisplay, setFileNameDisplay] = (0, $cozmU.useState)('');
    const [fileSizeBytes, setFileSizeBytes] = (0, $cozmU.useState)(0);
    const [filestoreId, setFilestoreId] = (0, $cozmU.useState)('');
    const [migrationScopeId, setMigrationScopeId] = (0, $cozmU.useState)('');
    const [migrationId, setMigrationId] = (0, $cozmU.useState)('');
    const [collectionId, setCollectionId] = (0, $cozmU.useState)('');
    const [shouldMapNotionMembers, setShouldMapNotionMembers] = (0, $cozmU.useState)(true);
    const [shouldRenderIntegrationTokenModal, setShouldRenderIntegrationTokenModal] = (0, $cozmU.useState)(false);
    const [shouldRenderCloseDrawerModal, setShouldRenderCloseDrawerModal] = (0, $cozmU.useState)(false);
    const [integrationToken, setIntegrationToken] = (0, $cozmU.useState)('');
    const [shouldAddRemainingMembers, setShouldAddRemainingMembers] = (0, $cozmU.useState)(true);
    const [shouldCopyPagePermissions, setShouldCopyPagePermissions] = (0, $cozmU.useState)(false);
    const [shouldRenderAccessTokenModal, setShouldRenderAccessTokenModal] = (0, $cozmU.useState)(false);
    const [shouldExportEntities, setShouldExportEntities] = (0, $cozmU.useState)(false);
    const [accessToken, setAccessToken] = (0, $cozmU.useState)('');
    const [refreshToken, setRefreshToken] = (0, $cozmU.useState)('');
    const [tokenExpireAt, setTokenExpireAt] = (0, $cozmU.useState)('');
    const [newSpaceName, setNewSpaceName] = (0, $cozmU.useState)('');
    const [existingSpace, setExistingSpace] = (0, $cozmU.useState)();
    const [parentPageId, setParentPageId] = (0, $cozmU.useState)();
    const [miroAuthToken, setMiroAuthToken] = (0, $cozmU.useState)('');
    const [miroTeamId, setMiroTeamId] = (0, $cozmU.useState)('');
    const [miroProjectId, setMiroProjectId] = (0, $cozmU.useState)(null);
    const [didReceiveMiroBulkApiTokens, setDidReceiveMiroBulkApiTokens] = (0, $cozmU.useState)(false);
    const [selectedPermissions, setSelectedPermissions] = (0, $cozmU.useState)((0, $8uc8a.PermissionOptions).DEFAULT);
    const [isNotionWorkspaceImportDisabled, setIsNotionWorkspaceImportDisabled] = (0, $cozmU.useState)(false);
    const [isValidatingZip, setIsValidatingZip] = (0, $cozmU.useState)(false);
    const clearAllMiroBulkImportTokens = ()=>{
        setMiroAuthToken('');
        setMiroTeamId('');
        setMiroProjectId(null);
    };
    const setParentPageIdWithValidation = (rawParentPageId)=>{
        if (rawParentPageId === 'no-page-selection') setParentPageId(undefined);
        else setParentPageId(rawParentPageId);
    };
    const setMiroProjectIdWithValidation = (rawMiroProjectId)=>{
        if (rawMiroProjectId === '' || rawMiroProjectId === null) setMiroProjectId(null);
        else setMiroProjectId(rawMiroProjectId);
    };
    (0, $27ffu.useBeforeUnload)('Changes may not be saved', isUploadingFile || isStartingImport);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c73c161a517b87e3$export$7805c3dc7bda328d.Provider, {
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value: {
            authProviderError: authProviderError,
            setAuthProviderError: setAuthProviderError,
            hasSubpages: hasSubpages,
            setHasSubpages: setHasSubpages,
            dropzoneCancelFnRef: dropzoneCancelFnRef,
            browserCancelFnRef: browserCancelFnRef,
            isUploadingFile: isUploadingFile,
            setIsUploadingFile: setIsUploadingFile,
            isStartingImport: isStartingImport,
            setIsStartingImport: setIsStartingImport,
            fileNameDisplay: fileNameDisplay,
            setFileNameDisplay: setFileNameDisplay,
            fileSizeBytes: fileSizeBytes,
            setFileSizeBytes: setFileSizeBytes,
            filestoreId: filestoreId,
            setFilestoreId: setFilestoreId,
            migrationScopeId: migrationScopeId,
            setMigrationScopeId: setMigrationScopeId,
            migrationId: migrationId,
            setMigrationId: setMigrationId,
            collectionId: collectionId,
            setCollectionId: setCollectionId,
            shouldMapNotionMembers: shouldMapNotionMembers,
            setShouldMapNotionMembers: setShouldMapNotionMembers,
            shouldRenderCloseDrawerModal: shouldRenderCloseDrawerModal,
            setShouldRenderCloseDrawerModal: setShouldRenderCloseDrawerModal,
            shouldRenderIntegrationTokenModal: shouldRenderIntegrationTokenModal,
            setShouldRenderIntegrationTokenModal: setShouldRenderIntegrationTokenModal,
            shouldExportEntities: shouldExportEntities,
            setShouldExportEntities: setShouldExportEntities,
            integrationToken: integrationToken,
            setIntegrationToken: setIntegrationToken,
            shouldAddRemainingMembers: shouldAddRemainingMembers,
            setShouldAddRemainingMembers: setShouldAddRemainingMembers,
            shouldCopyPagePermissions: shouldCopyPagePermissions,
            setShouldCopyPagePermissions: setShouldCopyPagePermissions,
            shouldRenderAccessTokenModal: shouldRenderAccessTokenModal,
            setShouldRenderAccessTokenModal: setShouldRenderAccessTokenModal,
            accessToken: accessToken,
            setAccessToken: setAccessToken,
            refreshToken: refreshToken,
            setRefreshToken: setRefreshToken,
            tokenExpireAt: tokenExpireAt,
            setTokenExpireAt: setTokenExpireAt,
            newSpaceName: newSpaceName,
            setNewSpaceName: setNewSpaceName,
            existingSpace: existingSpace,
            parentPageId: parentPageId,
            setParentPageId: setParentPageIdWithValidation,
            setExistingSpace: setExistingSpace,
            selectedPermissions: selectedPermissions,
            setSelectedPermissions: setSelectedPermissions,
            miroAuthToken: miroAuthToken,
            setMiroAuthToken: setMiroAuthToken,
            miroTeamId: miroTeamId,
            setMiroTeamId: setMiroTeamId,
            miroProjectId: miroProjectId,
            setMiroProjectId: setMiroProjectIdWithValidation,
            clearAllMiroBulkImportTokens: clearAllMiroBulkImportTokens,
            didReceiveMiroBulkApiTokens: didReceiveMiroBulkApiTokens,
            setDidReceiveMiroBulkApiTokens: setDidReceiveMiroBulkApiTokens,
            isNotionWorkspaceImportDisabled: isNotionWorkspaceImportDisabled,
            setIsNotionWorkspaceImportDisabled: setIsNotionWorkspaceImportDisabled,
            isValidatingZip: isValidatingZip,
            setIsValidatingZip: setIsValidatingZip
        }
    }, props.children);
};
const $c73c161a517b87e3$export$316a7de2e8141cc8 = (0, $kBr4q.createHook)($c73c161a517b87e3$export$390f32400eaf98c9);
const $c73c161a517b87e3$export$21ba04a22063ba7c = (0, $kBr4q.createActionsHook)($c73c161a517b87e3$export$390f32400eaf98c9);
module.exports["ImportContentWorkflowContext"] = $c73c161a517b87e3$export$7805c3dc7bda328d;
module.exports["ImportContentWorkflowContextProvider"] = $c73c161a517b87e3$export$4261666d8e0efef2;
module.exports["useImportContentStore"] = $c73c161a517b87e3$export$316a7de2e8141cc8;
module.exports["useImportContentStoreActions"] = $c73c161a517b87e3$export$21ba04a22063ba7c;

});

parcelRegister("8uc8a", function(module, exports) {
var $9db47457289923c5$export$e64befb57ff51d2d = /*#__PURE__*/ function(PermissionOptions) {
    PermissionOptions["RESTRICTED"] = "RESTRICTED";
    PermissionOptions["NOTION"] = "NOTION";
    PermissionOptions["DEFAULT"] = "DEFAULT";
    return PermissionOptions;
}({});
module.exports["PermissionOptions"] = $9db47457289923c5$export$e64befb57ff51d2d;

});

parcelRegister("27ffu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0a41942d2e8255bf$export$c0a586b329cae57d = (message, isUploadingFile)=>{
    (0, $cozmU.useEffect)(()=>{
        if (isUploadingFile) {
            const handleBeforeUnload = (event)=>{
                event.preventDefault(); // Required to trigger the dialog in some browsers
                event.returnValue = message;
            };
            window.addEventListener('beforeunload', handleBeforeUnload);
            return ()=>{
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }
    }, [
        message,
        isUploadingFile
    ]);
};
module.exports["useBeforeUnload"] = $0a41942d2e8255bf$export$c0a586b329cae57d;

});

parcelRegister("dzqet", function(module, exports) {
var $b9ba7ab256cbc974$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["NOTION"] = "NOTION";
    ContentType["MIRO"] = "MIRO";
    ContentType["HTML"] = "HTML";
    ContentType["MURAL"] = "MURAL";
    return ContentType;
}({});
module.exports["ContentType"] = $b9ba7ab256cbc974$export$e2e108cbe2e4f865;

});

parcelRegister("1DOZQ", function(module, exports) {

let $1320fdd063a75aa6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1320fdd063a75aa6$var$load("vsgOr"),
    $1320fdd063a75aa6$var$load("i313S"),
    $1320fdd063a75aa6$var$load("6wr18"),
    $1320fdd063a75aa6$var$load("9pso5"),
    $1320fdd063a75aa6$var$load("251nM"),
    $1320fdd063a75aa6$var$load("i0Zk0"),
    $1320fdd063a75aa6$var$load("4lI02"),
    $1320fdd063a75aa6$var$load("iWnyc"),
    $1320fdd063a75aa6$var$load("ffEVr"),
    $1320fdd063a75aa6$var$load("7EorR"),
    $1320fdd063a75aa6$var$load("hhss7"),
    $1320fdd063a75aa6$var$load("Wowvf"),
    $1320fdd063a75aa6$var$load("uvm9i"),
    $1320fdd063a75aa6$var$load("9JWXo")
]).then(()=>parcelRequire('hSRPs'));

});

parcelRegister("f8AFM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $jmjWc = parcelRequire("jmjWc");


var $5IN3L = parcelRequire("5IN3L");


var $dzqet = parcelRequire("dzqet");


const $123d8cc31f005f3d$var$ImportContentModalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "CsuHF",
    name: "ImportContentModalLoader",
    loader: async ()=>(await (parcelRequire("fuL7o"))).ImportContentModal
});
const $123d8cc31f005f3d$export$cf1f5228a529b27e = ()=>{
    const [importContentState, importContentActions] = (0, $5IN3L.useImportContentStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const makeCardClickHandler = (contentType)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'importContentCard',
                    source: 'importContentModal',
                    attributes: {
                        contentType: contentType
                    }
                }
            }).fire();
            importContentActions.setShowImportContentModal(false);
            importContentActions.setContentType(contentType);
            importContentActions.setShouldRenderDrawer(true);
            importContentActions.setShowImportContentDrawer(true);
        };
    return importContentState.shouldRenderModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($123d8cc31f005f3d$var$ImportContentModalLoader, {
        shouldRender: importContentState.showImportContentModal,
        onClose: ()=>importContentActions.setShowImportContentModal(false),
        onMiroClick: makeCardClickHandler((0, $dzqet.ContentType).MIRO),
        onNotionClick: makeCardClickHandler((0, $dzqet.ContentType).NOTION),
        onFileImportClick: makeCardClickHandler((0, $dzqet.ContentType).HTML),
        onMuralClick: makeCardClickHandler((0, $dzqet.ContentType).MURAL)
    }) : null;
};
module.exports["ConditionalImportContentModal"] = $123d8cc31f005f3d$export$cf1f5228a529b27e;

});

parcelRegister("fuL7o", function(module, exports) {

let $b47e35100332e9ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b47e35100332e9ec$var$load("6wr18"),
    $b47e35100332e9ec$var$load("ffEVr"),
    $b47e35100332e9ec$var$load("hhss7"),
    $b47e35100332e9ec$var$load("Wowvf"),
    $b47e35100332e9ec$var$load("hX5aL")
]).then(()=>parcelRequire('c6LMF'));

});

parcelRegister("gKGjM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $5n93X = parcelRequire("5n93X");


var $145zT = parcelRequire("145zT");


var $ad7Ou = parcelRequire("ad7Ou");


var $5IN3L = parcelRequire("5IN3L");

const $02de2c54d3c44def$var$i18n = (0, $kSwu1.defineMessages)({
    buttonText: {
        id: "import-content.button.text",
        defaultMessage: "Import from other tools"
    }
});
const $02de2c54d3c44def$export$b0d230bf69c0838c = ({ isMenuButton: isMenuButton = true, closePopup: closePopup })=>{
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, importContentActions] = (0, $5IN3L.useImportContentStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                source: 'importContentButton'
            }
        }).fire();
        importContentActions.setShouldRenderModal(true);
        importContentActions.setShowImportContentModal(true);
        closePopup?.('import content clicked');
    };
    return isMenuButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5n93X))), {
            label: "",
            color: "currentColor"
        }),
        onClick: handleClick,
        testId: "import-content-menu-button-nav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $02de2c54d3c44def$var$i18n.buttonText)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handleClick,
        appearance: "primary",
        testId: "import-content-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $02de2c54d3c44def$var$i18n.buttonText));
};
module.exports["ImportContentButton"] = $02de2c54d3c44def$export$b0d230bf69c0838c;

});

parcelRegister("5n93X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::641dd5d03db662197381257f8f1690c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e96216f98bcdad5$var$_react = $3e96216f98bcdad5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3e96216f98bcdad5$var$_baseNew = $3e96216f98bcdad5$var$_interopRequireDefault((parcelRequire("gElAV")));
function $3e96216f98bcdad5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cloud-arrow-up
 * Usage guidance:
 * Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e96216f98bcdad5$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $3e96216f98bcdad5$var$_react.default.createElement($3e96216f98bcdad5$var$_baseNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$3e96216f98bcdad5$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $3e96216f98bcdad5$var$_default = module.exports.default = $3e96216f98bcdad5$var$CloudArrowUpIcon;

});

parcelRegister("145zT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $KuePV = parcelRequire("KuePV");


var $h11I1 = parcelRequire("h11I1");

const $7d2b10ee608cb4d3$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(24);
    const { testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const t1 = isDisabled ? undefined : actions;
    const t2 = isDisabled ? undefined : actionsOnHover;
    let t3;
    if ($[0] !== ariaControls || $[1] !== ariaExpanded || $[2] !== ariaHasPopup || $[3] !== children || $[4] !== description || $[5] !== dropIndicator || $[6] !== elemAfter || $[7] !== elemBefore || $[8] !== forwardedRef || $[9] !== hasDragIndicator || $[10] !== interactionName || $[11] !== isContentTooltipDisabled || $[12] !== isDisabled || $[13] !== isDragging || $[14] !== isSelected || $[15] !== onClick || $[16] !== t1 || $[17] !== t2 || $[18] !== testId || $[19] !== visualContentRef) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KuePV.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            actions: t1,
            actionsOnHover: t2,
            onClick: onClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            isSelected: isSelected,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children);
        $[0] = ariaControls;
        $[1] = ariaExpanded;
        $[2] = ariaHasPopup;
        $[3] = children;
        $[4] = description;
        $[5] = dropIndicator;
        $[6] = elemAfter;
        $[7] = elemBefore;
        $[8] = forwardedRef;
        $[9] = hasDragIndicator;
        $[10] = interactionName;
        $[11] = isContentTooltipDisabled;
        $[12] = isDisabled;
        $[13] = isDragging;
        $[14] = isSelected;
        $[15] = onClick;
        $[16] = t1;
        $[17] = t2;
        $[18] = testId;
        $[19] = visualContentRef;
        $[20] = t3;
    } else t3 = $[20];
    let t4;
    if ($[21] !== listItemRef || $[22] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
            ref: listItemRef
        }, t3);
        $[21] = listItemRef;
        $[22] = t3;
        $[23] = t4;
    } else t4 = $[23];
    return t4;
} : ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
        ref: listItemRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KuePV.MenuItemBase), {
        testId: testId,
        description: description,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        isDisabled: isDisabled,
        /**
     * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
     * so they aren't rendered in the disabled state.
     */ actions: isDisabled ? undefined : actions,
        actionsOnHover: isDisabled ? undefined : actionsOnHover,
        onClick: onClick,
        ariaControls: ariaControls,
        ariaExpanded: ariaExpanded,
        ariaHasPopup: ariaHasPopup,
        isSelected: isSelected,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
});
module.exports["ButtonMenuItem"] = $7d2b10ee608cb4d3$export$6dc09b7c0ec1dfcd;

});

parcelRegister("lfopc", function(module, exports) {
$parcel$export(module.exports, "ConditionalSingleImportModal", () => (parcelRequire("l1elF")).ConditionalSingleImportModal);
$parcel$export(module.exports, "openSingleImportModal", () => (parcelRequire("l1elF")).openSingleImportModal);

var $l1elF = parcelRequire("l1elF");


});

parcelRegister("l1elF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");

const $2d0a0b5daed038e9$var$listeners = new Set();
const $2d0a0b5daed038e9$export$c880e43fcffc4ee6 = ()=>{
    $2d0a0b5daed038e9$var$listeners.forEach((listener)=>listener());
};
const $2d0a0b5daed038e9$var$useSingleImportModalState = ()=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const handleOpen = ()=>{
            setIsOpen(true);
        };
        $2d0a0b5daed038e9$var$listeners.add(handleOpen);
        return ()=>{
            $2d0a0b5daed038e9$var$listeners.delete(handleOpen);
        };
    }, []);
    const closeModal = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    return [
        isOpen,
        closeModal
    ];
};

// Modal component
const $2d0a0b5daed038e9$var$SingleImportModalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Q_fZz",
    name: "SingleImportModalLoader",
    loader: async ()=>(await (parcelRequire("1mnjJ"))).SingleImportModal
});
const $2d0a0b5daed038e9$export$c2504f474bd7d2f8 = ()=>{
    const [isOpen, closeModal] = $2d0a0b5daed038e9$var$useSingleImportModalState();
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d0a0b5daed038e9$var$SingleImportModalLoader, {
        isOpen: isOpen,
        onClose: closeModal
    }) : null;
};
module.exports["openSingleImportModal"] = $2d0a0b5daed038e9$export$c880e43fcffc4ee6;
module.exports["ConditionalSingleImportModal"] = $2d0a0b5daed038e9$export$c2504f474bd7d2f8;

});

parcelRegister("1mnjJ", function(module, exports) {

let $0fd9eed872c2a539$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0fd9eed872c2a539$var$load("6wr18"),
    $0fd9eed872c2a539$var$load("hhss7"),
    $0fd9eed872c2a539$var$load("ffEVr"),
    $0fd9eed872c2a539$var$load("8XUdf")
]).then(()=>parcelRequire('5WMB6'));

});

parcelRegister("i2el2", function(module, exports) {

let $d213892e4a393179$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d213892e4a393179$var$load("hEj0j"),
    $d213892e4a393179$var$load("ioRQV"),
    $d213892e4a393179$var$load("18viy"),
    $d213892e4a393179$var$load("9yvlB"),
    $d213892e4a393179$var$load("3gMot"),
    $d213892e4a393179$var$load("iysqm"),
    $d213892e4a393179$var$load("gRb8J"),
    $d213892e4a393179$var$load("85tgT"),
    $d213892e4a393179$var$load("aX6bV"),
    $d213892e4a393179$var$load("2KuvL"),
    $d213892e4a393179$var$load("cmmpX"),
    $d213892e4a393179$var$load("VXbA1"),
    $d213892e4a393179$var$load("4XoWv"),
    $d213892e4a393179$var$load("59hV4"),
    $d213892e4a393179$var$load("ariuh"),
    $d213892e4a393179$var$load("9MhVi"),
    $d213892e4a393179$var$load("97AsJ"),
    $d213892e4a393179$var$load("hMAqC"),
    $d213892e4a393179$var$load("9lZDf"),
    $d213892e4a393179$var$load("gr5FS"),
    $d213892e4a393179$var$load("i1bjU"),
    $d213892e4a393179$var$load("5t6mn"),
    $d213892e4a393179$var$load("bEfo8"),
    $d213892e4a393179$var$load("4zGQj"),
    $d213892e4a393179$var$load("hAlZp"),
    $d213892e4a393179$var$load("ea3NB"),
    $d213892e4a393179$var$load("isVeA"),
    $d213892e4a393179$var$load("6wr18"),
    $d213892e4a393179$var$load("7EorR"),
    $d213892e4a393179$var$load("7gPXS"),
    $d213892e4a393179$var$load("2ky8y"),
    $d213892e4a393179$var$load("d3BqY"),
    $d213892e4a393179$var$load("6vqGz"),
    $d213892e4a393179$var$load("cYv6T"),
    $d213892e4a393179$var$load("11yNG"),
    $d213892e4a393179$var$load("gQYVn"),
    $d213892e4a393179$var$load("9RGBF"),
    $d213892e4a393179$var$load("2iL13"),
    $d213892e4a393179$var$load("cpTbC"),
    $d213892e4a393179$var$load("fhT77"),
    $d213892e4a393179$var$load("jvUhP"),
    $d213892e4a393179$var$load("7sOKp"),
    $d213892e4a393179$var$load("7Ysw6"),
    $d213892e4a393179$var$load("3xL2F"),
    $d213892e4a393179$var$load("kMyku"),
    $d213892e4a393179$var$load("hG1ar"),
    $d213892e4a393179$var$load("5d2zd"),
    $d213892e4a393179$var$load("7zQG2"),
    $d213892e4a393179$var$load("dq8fV"),
    $d213892e4a393179$var$load("aR5ri"),
    $d213892e4a393179$var$load("2cZju"),
    $d213892e4a393179$var$load("ffEVr"),
    $d213892e4a393179$var$load("g0T7B"),
    $d213892e4a393179$var$load("1VQii"),
    $d213892e4a393179$var$load("hhss7"),
    $d213892e4a393179$var$load("Wowvf"),
    $d213892e4a393179$var$load("vsgOr"),
    $d213892e4a393179$var$load("i313S"),
    $d213892e4a393179$var$load("aAWLw"),
    $d213892e4a393179$var$load("jfFQG")
]).then(()=>parcelRequire('72dQ5'));

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("hGf3w", function(module, exports) {

let $cdf209b2ee114b80$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cdf209b2ee114b80$var$load("9NRga"),
    $cdf209b2ee114b80$var$load("dIKKx")
]).then(()=>parcelRequire('eYRFW'));

});

parcelRegister("e5nB1", function(module, exports) {

let $a413d608d023026c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a413d608d023026c$var$load("52dqm").then(()=>parcelRequire('3zSMJ'));

});

parcelRegister("dNNUs", function(module, exports) {

let $a0c690f539974e4a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a0c690f539974e4a$var$load("9NRga"),
    $a0c690f539974e4a$var$load("gIOIL")
]).then(()=>parcelRequire('gLUng'));

});

parcelRegister("kqYDv", function(module, exports) {

let $ee05456ab74e766d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ee05456ab74e766d$var$load("vsgOr"),
    $ee05456ab74e766d$var$load("i313S"),
    $ee05456ab74e766d$var$load("6wr18"),
    $ee05456ab74e766d$var$load("ffEVr"),
    $ee05456ab74e766d$var$load("kGPoW")
]).then(()=>parcelRequire('7WjUL'));

});

parcelRegister("7NHN3", function(module, exports) {

var $kEPax = parcelRequire("kEPax");

const $b15c706fb306d92c$export$39b0f5626e96f41e = (0, $kEPax.useMessageInstanceEvent);
module.exports["useMessageInstanceEvent"] = $b15c706fb306d92c$export$39b0f5626e96f41e;

});

parcelRegister("93Gae", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $6UvXN = parcelRequire("6UvXN");

const $081573ec09156b80$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    isFullScreenModalAvailable: false,
    initialPrompt: undefined,
    openWithChatHistory: false,
    targetConversationId: null,
    autoFocusInput: true,
    wasAutoOpened: false,
    editorHadFocusBeforeChatOpen: false
};
const $081573ec09156b80$var$store = (0, $8s9DV.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $081573ec09156b80$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($081573ec09156b80$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode,
                    wasAutoOpened: false
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        setOpenWithChatHistory: (openWithChatHistory)=>({ setState: setState })=>{
                setState({
                    openWithChatHistory: openWithChatHistory
                });
            },
        setTargetConversationId: (targetConversationId)=>({ setState: setState })=>{
                setState({
                    targetConversationId: targetConversationId
                });
            },
        setWasAutoOpened: (wasAutoOpened)=>({ setState: setState })=>{
                setState({
                    wasAutoOpened: wasAutoOpened
                });
            },
        setEditorHadFocusBeforeChatOpen: (editorHadFocusBeforeChatOpen)=>({ setState: setState })=>{
                setState({
                    editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt, autoFocusInput: autoFocusInput = true })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined,
                        autoFocusInput: true,
                        wasAutoOpened: false
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
              which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                }
            },
        openConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt, autoFocusInput: autoFocusInput = true })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // Already in the desired mode — ensure the sidebar is actually
                // visible (it may have been displaced by another panel) but
                // otherwise treat this as a no-op.
                if (currentMode === targetMode) {
                    if (targetMode === (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR && !sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                    return;
                }
                // Switch to the target mode
                switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        // wasAutoOpened is managed by the dedicated setWasAutoOpened action and reset on close/toggle/setMode.
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            },
        setIsFullScreenModalAvailable: (isFullScreenModalAvailable)=>({ setState: setState })=>{
                setState({
                    isFullScreenModalAvailable: isFullScreenModalAvailable
                });
            }
    }
});
const $081573ec09156b80$var$useStore = (0, $kBr4q.createHook)($081573ec09156b80$var$store);
const $081573ec09156b80$export$37440b51449f7ac6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(22);
    const [t0, t1] = $081573ec09156b80$var$useStore();
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, isFullScreenModalAvailable: isFullScreenModalAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, targetConversationId: targetConversationId, autoFocusInput: autoFocusInput, wasAutoOpened: wasAutoOpened, editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen } = t0;
    const { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setTargetConversationId: setTargetConversationId, setWasAutoOpened: setWasAutoOpened, setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable, setIsFullScreenModalAvailable: setIsFullScreenModalAvailable } = t1;
    let t2;
    if ($[0] !== autoFocusInput || $[1] !== clearInitialPrompt || $[2] !== editorHadFocusBeforeChatOpen || $[3] !== initialPrompt || $[4] !== isFullScreenModalAvailable || $[5] !== isMiniModalAvailable || $[6] !== isSidebarAvailable || $[7] !== mode || $[8] !== openConversationAssistantUIMode || $[9] !== openWithChatHistory || $[10] !== reset || $[11] !== setEditorHadFocusBeforeChatOpen || $[12] !== setIsFullScreenModalAvailable || $[13] !== setIsMiniModalAvailable || $[14] !== setIsSidebarAvailable || $[15] !== setOpenWithChatHistory || $[16] !== setTargetConversationId || $[17] !== setWasAutoOpened || $[18] !== targetConversationId || $[19] !== toggleConversationAssistantUIMode || $[20] !== wasAutoOpened) {
        t2 = {
            mode: mode,
            initialPrompt: initialPrompt,
            openWithChatHistory: openWithChatHistory,
            targetConversationId: targetConversationId,
            autoFocusInput: autoFocusInput,
            wasAutoOpened: wasAutoOpened,
            editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen,
            reset: reset,
            clearInitialPrompt: clearInitialPrompt,
            setOpenWithChatHistory: setOpenWithChatHistory,
            setTargetConversationId: setTargetConversationId,
            setWasAutoOpened: setWasAutoOpened,
            setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen,
            toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
            openConversationAssistantUIMode: openConversationAssistantUIMode,
            setIsMiniModalAvailable: setIsMiniModalAvailable,
            setIsSidebarAvailable: setIsSidebarAvailable,
            setIsFullScreenModalAvailable: setIsFullScreenModalAvailable,
            isMiniModalAvailable: isMiniModalAvailable,
            isSidebarAvailable: isSidebarAvailable,
            isFullScreenModalAvailable: isFullScreenModalAvailable
        };
        $[0] = autoFocusInput;
        $[1] = clearInitialPrompt;
        $[2] = editorHadFocusBeforeChatOpen;
        $[3] = initialPrompt;
        $[4] = isFullScreenModalAvailable;
        $[5] = isMiniModalAvailable;
        $[6] = isSidebarAvailable;
        $[7] = mode;
        $[8] = openConversationAssistantUIMode;
        $[9] = openWithChatHistory;
        $[10] = reset;
        $[11] = setEditorHadFocusBeforeChatOpen;
        $[12] = setIsFullScreenModalAvailable;
        $[13] = setIsMiniModalAvailable;
        $[14] = setIsSidebarAvailable;
        $[15] = setOpenWithChatHistory;
        $[16] = setTargetConversationId;
        $[17] = setWasAutoOpened;
        $[18] = targetConversationId;
        $[19] = toggleConversationAssistantUIMode;
        $[20] = wasAutoOpened;
        $[21] = t2;
    } else t2 = $[21];
    return t2;
} : ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, isFullScreenModalAvailable: isFullScreenModalAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, targetConversationId: targetConversationId, autoFocusInput: autoFocusInput, wasAutoOpened: wasAutoOpened, editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen }, { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setTargetConversationId: setTargetConversationId, setWasAutoOpened: setWasAutoOpened, setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable, setIsFullScreenModalAvailable: setIsFullScreenModalAvailable }] = $081573ec09156b80$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        openWithChatHistory: openWithChatHistory,
        targetConversationId: targetConversationId,
        autoFocusInput: autoFocusInput,
        wasAutoOpened: wasAutoOpened,
        editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        setOpenWithChatHistory: setOpenWithChatHistory,
        setTargetConversationId: setTargetConversationId,
        setWasAutoOpened: setWasAutoOpened,
        setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        openConversationAssistantUIMode: openConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        setIsFullScreenModalAvailable: setIsFullScreenModalAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable,
        isFullScreenModalAvailable: isFullScreenModalAvailable
    };
};
const $081573ec09156b80$export$66cf76b7e04da11f = (0, $kBr4q.createActionsHook)($081573ec09156b80$var$store);
module.exports["useRovoExperienceAPIStore"] = $081573ec09156b80$export$37440b51449f7ac6;

});

parcelRegister("6UvXN", function(module, exports) {
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ const $7c0481f515a47ac9$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal',
    FULL_SCREEN_MODAL: 'full-screen-modal'
};
module.exports["ConversationAssistantUIModes"] = $7c0481f515a47ac9$export$bc36ebf73899a71d;

});

parcelRegister("lQXDC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $emZLc = parcelRequire("emZLc");


var $66Bcq = parcelRequire("66Bcq");


var $gBjHb = parcelRequire("gBjHb");

const $71fb2a898293aa35$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))));
};
const $71fb2a898293aa35$export$34282a1f95511a11 = (props)=>{
    const data = $71fb2a898293aa35$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children));
};
module.exports["ContextWrapper"] = $71fb2a898293aa35$export$34282a1f95511a11;

});

parcelRegister("6htAj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lzgC6 = parcelRequire("lzgC6");


var $jYwtP = parcelRequire("jYwtP");


var $hcOES = parcelRequire("hcOES");

const $503cc92bec887db5$var$getFixedActionAndActionSubject = (props)=>{
    const { eventName: eventName, action: action, actionSubject: actionSubject } = props;
    if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
    const eventNameSplit = eventName ? eventName.split(' ') : [];
    const fixedAction = action || eventNameSplit[1];
    const fixedActionSubject = actionSubject || eventNameSplit[0];
    if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
    return {
        action: fixedAction,
        actionSubject: fixedActionSubject
    };
};
const $503cc92bec887db5$var$getFixedActionSubjectId = (props)=>{
    const { componentName: componentName, actionSubjectId: actionSubjectId } = props;
    if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
    const fixedActionSubjectId = actionSubjectId || componentName;
    return {
        actionSubjectId: fixedActionSubjectId
    };
};
class $503cc92bec887db5$var$FireComponent extends (0, $cozmU.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes } = this.props;
        if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
        const { action: action, actionSubject: actionSubject } = $503cc92bec887db5$var$getFixedActionAndActionSubject(this.props);
        const { actionSubjectId: actionSubjectId } = $503cc92bec887db5$var$getFixedActionSubjectId(this.props);
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $hcOES.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $503cc92bec887db5$var$WithAnalytics = (0, $lzgC6.default)()($503cc92bec887db5$var$FireComponent);
const $503cc92bec887db5$export$1f3555c9be6c5e08 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($503cc92bec887db5$var$WithAnalytics, {
        ...props,
        type: (0, $jYwtP.UI_EVENT_TYPE)
    });
const $503cc92bec887db5$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($503cc92bec887db5$var$WithAnalytics, {
        ...props,
        type: (0, $jYwtP.TRACK_EVENT_TYPE)
    });
const $503cc92bec887db5$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($503cc92bec887db5$var$WithAnalytics, {
        ...props,
        type: (0, $jYwtP.OPERATIONAL_EVENT_TYPE)
    });
const $503cc92bec887db5$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($503cc92bec887db5$var$WithAnalytics, {
        ...props,
        type: (0, $jYwtP.SCREEN_EVENT_TYPE),
        eventName: "screen viewed"
    });
module.exports["FireOperationalAnalytics"] = $503cc92bec887db5$export$b71c3ada5d4ec5da;
module.exports["FireScreenAnalytics"] = $503cc92bec887db5$export$2ccf161b817b43b;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("8AKrx", function(module, exports) {

var $jo3kP = parcelRequire("jo3kP");


var $51OMi = parcelRequire("51OMi");


var $9wGTI = parcelRequire("9wGTI");


var $dIgcq = parcelRequire("dIgcq");


var $biOtS = parcelRequire("biOtS");


var $9CZiz = parcelRequire("9CZiz");








var $1zMDo = parcelRequire("1zMDo");


var $1LmRa = parcelRequire("1LmRa");


var $pUzjH = parcelRequire("pUzjH");


var $aoPxZ = parcelRequire("aoPxZ");


var $hYAxW = parcelRequire("hYAxW");


var $1Hbkf = parcelRequire("1Hbkf");

const $54349ac24c29d21a$var$MAX_FEATURE_VISIT_COUNT = 3;
const $54349ac24c29d21a$export$da8724bcb6526688 = 'crossJoinNudgesV3';
const $54349ac24c29d21a$export$49a8cf368338c69c = async ({ userId: userId, cloudId: cloudId, getMSRNudgeRecommendations: getMSRNudgeRecommendations })=>{
    const cachedUserIsTooNew = (0, $hYAxW.withEligibilityCache)('user_is_too_new', (0, $aoPxZ.isUserTooNew), 1);
    if ((0, $1Hbkf.getFeatureVisitedCount)($54349ac24c29d21a$export$da8724bcb6526688) >= $54349ac24c29d21a$var$MAX_FEATURE_VISIT_COUNT) return {
        ineligibilityReason: 'FEATURE_VISITED_COUNT_MAXED_OUT'
    };
    if ((0, $1Hbkf.isUserOptedOut)($54349ac24c29d21a$export$da8724bcb6526688)) return {
        ineligibilityReason: 'USER_HAS_OPTED_OUT'
    };
    if (await (0, $pUzjH.isSiteOptedOut)(cloudId)) return {
        ineligibilityReason: 'SITE_OPTED_OUT'
    };
    if (await (0, $1LmRa.hasAccessToProduct)('jira-software', cloudId)) return {
        ineligibilityReason: 'ALREADY_HAVE_ACCESS'
    };
    if (await cachedUserIsTooNew(cloudId, userId, 'confluence_first_active')) return {
        ineligibilityReason: 'USER_IS_TOO_NEW'
    };
    const collaborators = await (0, $jo3kP.getUsersFromCollaborationGraph)('crossJoinNudgesV3', cloudId, userId);
    if (collaborators === undefined || collaborators.length === 0) return {
        ineligibilityReason: 'NO_COLLABORATORS_FOUND'
    };
    const collaboratorsWithJiraAccess = await (0, $51OMi.getCollaboratorsWithJiraAccess)(cloudId, collaborators);
    if (collaboratorsWithJiraAccess.length === 0) return {
        ineligibilityReason: 'COLLABORATORS_HAVE_NO_ACCESS'
    };
    if (!await (0, $9CZiz.canUserRequestAccess)('jira-software', cloudId)) return {
        ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
    };
    if (!await (0, $1zMDo.isSite7DaysOld)('jira-software', cloudId)) return {
        ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
    };
    const recommendations = await getMSRNudgeRecommendations();
    if (!recommendations.includes('cjn-conf-jira-v3')) return {
        ineligibilityReason: 'MSR_NUDGE_NOT_RECOMMENDED'
    };
    return {
        ineligibilityReason: null,
        collaborators: collaboratorsWithJiraAccess
    };
};





























const $15b4e34a7ce1da70$var$MAX_FEATURE_VISIT_COUNT = 3;
const $15b4e34a7ce1da70$export$6353fe5db4bd7dca = 'crossJoinNudgesConfluenceToJpd';
const $15b4e34a7ce1da70$export$8916d0e9bd8973b7 = async (cloudId, userId)=>{
    const cachedUserIsTooNew = (0, $hYAxW.withEligibilityCache)('user_is_too_new', (0, $aoPxZ.isUserTooNew), 1);
    if ((0, $1Hbkf.getFeatureVisitedCount)($15b4e34a7ce1da70$export$6353fe5db4bd7dca) >= $15b4e34a7ce1da70$var$MAX_FEATURE_VISIT_COUNT) return {
        eligible: false,
        ineligibilityReason: 'FEATURE_VISITED_COUNT_MAXED_OUT'
    };
    if ((0, $1Hbkf.isUserOptedOut)($15b4e34a7ce1da70$export$6353fe5db4bd7dca)) return {
        eligible: false,
        ineligibilityReason: 'USER_HAS_OPTED_OUT'
    };
    if (await (0, $pUzjH.isSiteOptedOut)(cloudId)) return {
        eligible: false,
        ineligibilityReason: 'SITE_OPTED_OUT'
    };
    if (await (0, $1LmRa.hasAccessToProduct)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'ALREADY_HAVE_ACCESS'
    };
    if (await cachedUserIsTooNew(cloudId, userId, 'confluence_first_active')) return {
        eligible: false,
        ineligibilityReason: 'USER_IS_TOO_NEW'
    };
    if (!await (0, $1zMDo.isSite7DaysOld)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
    };
    if (!await (0, $9CZiz.canUserRequestAccess)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
    };
    return {
        eligible: true
    };
};


const $3e82bea0d95824c0$export$9d305ebad2a9218a = async ({ cloudId: cloudId, userId: userId, flags: flags, createAnalyticsEvent: createAnalyticsEvent, push: push, getMSRNudgeRecommendations: getMSRNudgeRecommendations })=>{
    const analytics = (0, $biOtS.getExperimentAnalytics)((0, $54349ac24c29d21a$export$da8724bcb6526688), createAnalyticsEvent);
    try {
        if (!userId || await (0, $1Hbkf.isFeatureVisited)((0, $54349ac24c29d21a$export$da8724bcb6526688))) return;
        const response = await (0, $54349ac24c29d21a$export$49a8cf368338c69c)({
            userId: userId,
            cloudId: cloudId,
            getMSRNudgeRecommendations: getMSRNudgeRecommendations
        });
        if (response.ineligibilityReason === null) {
            await (0, $dIgcq.showNudgeFlag)({
                product: 'jira-software',
                integration: (0, $54349ac24c29d21a$export$da8724bcb6526688),
                userId: userId,
                cloudId: cloudId,
                collaborators: response.collaborators,
                createAnalyticsEvent: createAnalyticsEvent,
                flags: flags,
                pushRoute: push,
                onDisplayed: (0, $9wGTI.fg)('con-cjn-fix-orchestrator-block-handling-gate') ? ()=>{
                    (0, $1Hbkf.increaseFeatureVisitedCount)((0, $54349ac24c29d21a$export$da8724bcb6526688));
                    (0, $hYAxW.setHasSeenNudgeInLast7Days)();
                } : undefined
            });
            if (!(0, $9wGTI.fg)('con-cjn-fix-orchestrator-block-handling-gate')) {
                (0, $1Hbkf.increaseFeatureVisitedCount)((0, $54349ac24c29d21a$export$da8724bcb6526688));
                // this is used in the eligibility check for loom nudge
                await (0, $hYAxW.setHasSeenNudgeInLast7Days)();
            }
        } else if (response.ineligibilityReason === 'SITE_OPTED_OUT') (0, $biOtS.fireSiteOptedOutAnalytics)(analytics);
        else if (response.ineligibilityReason === 'MSR_NUDGE_NOT_RECOMMENDED') (0, $biOtS.fireMsrNotRecommendedAnalytics)(analytics, 'cjn-conf-jira-v3');
    } catch (error) {
        (0, $biOtS.fireExperimentError)(analytics, error);
    }
};
const $3e82bea0d95824c0$export$db3bc6af881f6bd0 = async ({ cloudId: cloudId, userId: userId, createAnalyticsEvent: createAnalyticsEvent, getMSRNudgeRecommendations: getMSRNudgeRecommendations })=>{
    const analytics = (0, $biOtS.getExperimentAnalytics)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca), createAnalyticsEvent);
    try {
        if (!userId) return false;
        if (await (0, $1Hbkf.isFeatureVisited)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca))) return false;
        const eligibilityResponse = await (0, $15b4e34a7ce1da70$export$8916d0e9bd8973b7)(cloudId, userId);
        if (!eligibilityResponse.eligible) {
            if (eligibilityResponse.ineligibilityReason === 'SITE_OPTED_OUT') (0, $biOtS.fireSiteOptedOutAnalytics)(analytics);
            return false;
        }
        const recommendations = await getMSRNudgeRecommendations();
        if (!recommendations.includes('cjn-conf-jpd')) {
            (0, $biOtS.fireMsrNotRecommendedAnalytics)(analytics, 'cjn-conf-jpd');
            return false;
        }
        return true;
    } catch (error) {
        (0, $biOtS.fireExperimentError)(analytics, error);
        return false;
    }
};
const $3e82bea0d95824c0$export$2cec488374560b5c = async ({ cloudId: cloudId, userId: userId, flags: flags, createAnalyticsEvent: createAnalyticsEvent, push: push })=>{
    const analytics = (0, $biOtS.getExperimentAnalytics)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca), createAnalyticsEvent);
    try {
        if (!userId) return;
        const collaborators = await (0, $jo3kP.getUsersFromCollaborationGraph)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca), cloudId, userId);
        const collaboratorsOnJpd = await (0, $51OMi.getUsersWithProductAccess)('jira-product-discovery', cloudId, collaborators);
        await (0, $dIgcq.showNudgeFlag)({
            product: 'jira-product-discovery',
            integration: (0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca),
            userId: userId,
            cloudId: cloudId,
            collaborators: collaboratorsOnJpd,
            createAnalyticsEvent: createAnalyticsEvent,
            flags: flags,
            pushRoute: push,
            onDisplayed: (0, $9wGTI.fg)('con-cjn-fix-orchestrator-block-handling-gate') ? ()=>{
                (0, $1Hbkf.increaseFeatureVisitedCount)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca));
                (0, $hYAxW.setHasSeenNudgeInLast7Days)();
            } : undefined
        });
        if (!(0, $9wGTI.fg)('con-cjn-fix-orchestrator-block-handling-gate')) {
            (0, $1Hbkf.increaseFeatureVisitedCount)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca));
            // this is used in the eligibility check for loom nudge
            await (0, $hYAxW.setHasSeenNudgeInLast7Days)();
        }
    } catch (error) {
        (0, $biOtS.fireExperimentError)(analytics, error);
    }
};
module.exports["triggerJiraCrossJoinNudge"] = $3e82bea0d95824c0$export$9d305ebad2a9218a;
module.exports["checkJpdCrossJoinNudgeEligibility"] = $3e82bea0d95824c0$export$db3bc6af881f6bd0;
module.exports["showJpdCrossJoinNudge"] = $3e82bea0d95824c0$export$2cec488374560b5c;

});

parcelRegister("jo3kP", function(module, exports) {
const $2034ef6195fd7775$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $2034ef6195fd7775$export$f757fae6e9facd6f = async (integration, cloudId, userId)=>{
    const payload = {
        context: {
            contextType: integration,
            principalId: userId,
            siteId: cloudId
        },
        modelRequestParams: {
            experience: 'CgUserNearbyUser'
        },
        expanded: true,
        maxNumberOfResults: $2034ef6195fd7775$var$COLLABORATION_GRAPH_MAX_RESULTS,
        userId: userId
    };
    const response = await fetch('/gateway/api/collaboration/v1/collaborationgraph/user/user', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    const result = (await response.json())?.collaborationGraphEntities?.filter((en)=>en?.userProfile !== undefined && en?.userProfile?.account_type !== 'app' && en?.userProfile?.account_status !== 'deactivated' && en?.userProfile?.account_status !== 'deleted').map(({ userProfile: { account_id: account_id, name: name, picture: picture } })=>({
            id: account_id,
            name: name,
            avatar: picture
        }));
    return result;
};
module.exports["getUsersFromCollaborationGraph"] = $2034ef6195fd7775$export$f757fae6e9facd6f;

});

parcelRegister("51OMi", function(module, exports) {
const $6a89ce1698025952$export$8db0f1e8ecc00a3f = async (cloudId, collaborators)=>{
    const accountIds = collaborators.map((c)=>c.id);
    const response = await fetch('/gateway/api/growth/cross-join-nudges-v3/get-permitted-jira-users', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            cloudId: cloudId,
            accountIds: accountIds
        })
    });
    const returnedAccountIds = await response.json();
    return collaborators.filter((c)=>returnedAccountIds.includes(c.id));
};
const $6a89ce1698025952$export$a68fadaa3a8b5e25 = async (product, cloudId, collaborators)=>{
    const response = await fetch('/gateway/api/growth/invite-on-link-insert/get-invitees', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            cloudId: cloudId,
            product: product,
            accountIds: collaborators.map((c)=>c.id)
        })
    });
    const returnedAccountIds = await response.json();
    return collaborators.filter((c)=>!returnedAccountIds.includes(c.id));
};
module.exports["getCollaboratorsWithJiraAccess"] = $6a89ce1698025952$export$8db0f1e8ecc00a3f;
module.exports["getUsersWithProductAccess"] = $6a89ce1698025952$export$a68fadaa3a8b5e25;

});

parcelRegister("dIgcq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");





var $kSwu1 = parcelRequire("kSwu1");


var $FKQbh = parcelRequire("FKQbh");


var $24dy7 = parcelRequire("24dy7");


var $i1t43 = parcelRequire("i1t43");

const $fd9fd199a3b7c9b9$export$2a1baa97ca79d572 = {
    confluence: 'Confluence',
    jira: 'Jira',
    'jira-software': 'Jira',
    'jira-product-discovery': 'Jira Product Discovery',
    loom: 'Loom'
};
const $fd9fd199a3b7c9b9$export$44fea6589b7ddc92 = (product)=>$fd9fd199a3b7c9b9$export$2a1baa97ca79d572[product];






var $64VTj = parcelRequire("64VTj");


var $f95Dj = parcelRequire("f95Dj");


var $5Oxbb = parcelRequire("5Oxbb");




function $3b0e15b83427a2df$export$5ac26fa9b941854e(locale) {
    const [messages, setMessages] = (0, $cozmU.useState)({});
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        let isMounted = true;
        async function startToFetchMessagesByLocale() {
            // Intl.Locale doesn't like underscores
            const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
            try {
                setIsLoading(true);
                const module = await $3b0e15b83427a2df$export$c08b58fa4727b0d2(finalLocale);
                const newMessages = module.default || module;
                if (isMounted) setMessages(newMessages);
            } catch (// eslint-disable-next-line no-unused-vars
            e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                if (isMounted) setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
        return ()=>{
            isMounted = false;
        };
    }, [
        locale
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}


























function $3b0e15b83427a2df$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("6uNie"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("6cQbT"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("72aOG"));
        case 'en-GB':
            return (parcelRequire("bdD5z"));
        case 'en-AU':
        case 'en-US':
        case 'en':
            return Promise.resolve((parcelRequire("5Oxbb")));
        case 'en-ZZ':
            return (parcelRequire("21tbY"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("k6Zzx"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("c37Dw"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("8Q9xo"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("gGKzJ"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("6czGb"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("2p4st"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("g0V0w"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("i49cs"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("hh0LP"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("4wFLD"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("krd9P"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("cHRau"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("4Do55"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("1F4sI"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("8X4YJ"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("80mgK"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("l5HJG"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("954mw"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("6XRgG"));
        default:
            return Promise.resolve((parcelRequire("5Oxbb")));
    }
}


























function $3b0e15b83427a2df$export$65a15453632bd60b(locale) {
    // Normalize locale to match global-shortcuts format
    const normalizedLocale = locale.replace('_', '-');
    const languageLocale = normalizedLocale.split(/[-_]/)[0] || 'en';
    switch(normalizedLocale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("1u8h5"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("cdH9i"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("cz9pu"));
        case 'en-GB':
            return (parcelRequire("jd6mw"));
        case 'en-AU':
        case 'en-US':
        case 'en':
            return Promise.resolve((parcelRequire("f95Dj")));
        case 'en-ZZ':
            return (parcelRequire("7jvTN"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("3dSeZ"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("acRdm"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("4cfRQ"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("79Hva"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("3xT0A"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("2JjE4"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("8OdBn"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("bNEyW"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("9DLIE"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("hqvUB"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("5yUny"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("bOdwX"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("fQzFJ"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("ghLcq"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("kKATp"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("htZTG"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("jIPaw"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("8ep6a"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("27H1Y"));
        default:
            // Fallback to language code if specific locale not found
            if (languageLocale === 'en') return Promise.resolve((parcelRequire("f95Dj")));
    }
    return Promise.resolve({
        default: {}
    });
}


// Merge default English messages at module level to avoid missing translation errors
const $36b44e2fc0c3140b$var$DEFAULT_MERGED_MESSAGES = {
    ...(0, $f95Dj.default),
    ...(0, $5Oxbb.default)
};
const $36b44e2fc0c3140b$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        // Normalize locale - Intl.Locale doesn't like underscores
        const normalizedLocale = locale.replace('_', '-');
        const finalLocale = new Intl.Locale(normalizedLocale).toString();
        // Fetch messages from both packages in parallel
        const [crossJoinNudgesModule, globalShortcutsModule] = await Promise.all([
            (0, $3b0e15b83427a2df$export$c08b58fa4727b0d2)(finalLocale).catch(()=>({
                    default: {}
                })),
            (0, $3b0e15b83427a2df$export$65a15453632bd60b)(finalLocale).catch(()=>({
                    default: {}
                }))
        ]);
        const crossJoinNudgesMessages = crossJoinNudgesModule.default || crossJoinNudgesModule;
        const globalShortcutsMessages = globalShortcutsModule.default || globalShortcutsModule;
        // Merge messages: cross-join-nudges messages take precedence over global-shortcuts
        // Start with defaults, then override with locale-specific messages
        const mergedMessages = {
            ...$36b44e2fc0c3140b$var$DEFAULT_MERGED_MESSAGES,
            ...globalShortcutsMessages,
            ...crossJoinNudgesMessages
        };
        return mergedMessages;
    } catch (// eslint-disable-next-line no-unused-vars
    e) {
        // If loading fails, return default messages
        return $36b44e2fc0c3140b$var$DEFAULT_MERGED_MESSAGES;
    }
};
const $36b44e2fc0c3140b$export$c5d7da1d3dca7da2 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
        defaultMessages: $36b44e2fc0c3140b$var$DEFAULT_MERGED_MESSAGES,
        loaderFn: $36b44e2fc0c3140b$export$2b153a2030b0feb2
    }, children);
function $36b44e2fc0c3140b$export$2a4cd3780f93f2ef(Component) {
    return function WithLocalIntlComponent(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($36b44e2fc0c3140b$export$c5d7da1d3dca7da2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props));
    };
}





const $8b1c2e51650669b7$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "cross-join-nudges.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to {product}"
    },
    description: {
        id: "cross-join-nudges.request-access-error-flag.description-support-link",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>."
    }
});


const $753d7ede47f8ecd1$var$SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $753d7ede47f8ecd1$export$e1d0d64874873c8b = (0, $36b44e2fc0c3140b$export$2a4cd3780f93f2ef)(({ onDismiss: onDismiss, targetProduct: targetProduct, flagComponent: FlagComponent = (0, $FKQbh.default), ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FlagComponent, {
        ...props,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        onDismissed: onDismiss,
        title: formatMessage((0, $8b1c2e51650669b7$export$defe85febe8b728c).title, {
            product: (0, $fd9fd199a3b7c9b9$export$44fea6589b7ddc92)(targetProduct)
        }),
        description: formatMessage((0, $8b1c2e51650669b7$export$defe85febe8b728c).description, {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: $753d7ede47f8ecd1$var$SUPPORT_LINK
                }, chunks)
        })
    });
});


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $jEK83 = parcelRequire("jEK83");





var $cXtTj = parcelRequire("cXtTj");





var $fodiz = parcelRequire("fodiz");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");








var $bcDqz = parcelRequire("bcDqz");


var $lpNn5 = parcelRequire("lpNn5");

const $4b57740a6d1321ca$var$MAX_AVATARS_FEATURED_BOTTOM = 4;
const $4b57740a6d1321ca$var$MAX_AVATARS_FEATURED_TOP = 2;
const $4b57740a6d1321ca$export$29beada2d5f93289 = ({ position: position = 'bottom', data: data, ...props })=>{
    const maxAvatarCount = position === 'top' ? $4b57740a6d1321ca$var$MAX_AVATARS_FEATURED_TOP : $4b57740a6d1321ca$var$MAX_AVATARS_FEATURED_BOTTOM;
    const tooltipPosition = position;
    const { data: customData, overrides: customOverrides } = (0, $cozmU.useMemo)(()=>$4b57740a6d1321ca$export$bc55c1ff86d63c4d({
            data: data,
            maxAvatarCount: maxAvatarCount
        }), [
        data,
        maxAvatarCount
    ]);
    const avatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
        maxCount: maxAvatarCount,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        tooltipPosition: tooltipPosition,
        onMoreClick: (0, (/*@__PURE__*/$parcel$interopDefault($jEK83))),
        ...props
    });
    return avatarGroup;
};
const $4b57740a6d1321ca$export$bc55c1ff86d63c4d = ({ data: users, maxAvatarCount: maxAvatarCount = $4b57740a6d1321ca$var$MAX_AVATARS_FEATURED_BOTTOM })=>{
    const lastFeaturedUser = maxAvatarCount - 1;
    const overflowUsers = users.slice(lastFeaturedUser);
    const overrides = {
        MoreIndicator: {
            render: (Component, componentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: overflowUsers.map((u)=>u.name).join(', '),
                    position: "top"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    ...componentProps,
                    borderColor: "none",
                    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jEK83)))
                }))
        }
    };
    return {
        overrides: overrides,
        data: users
    };
};




/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $hBYtq = parcelRequire("hBYtq");

const $909efa727c14d75b$var$styles = {
    button: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _4c065UPgdg _2Y7lL4Pgdg _0KLXru66of _1UtDYzM7Tp _1kk5Tkf7mX _1EqgXlb1xp _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
};
const $909efa727c14d75b$export$29d11c0fe2fc51d8 = ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        onClick: onClick,
        xcss: $909efa727c14d75b$var$styles.button
    }, children);
};





const $69f23a7fc0e94082$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "cross-join-nudges.request-access-prompt-flag.title",
        defaultMessage: "Your team is now using {product}"
    },
    titleReminder: {
        id: "cross-join-nudges.request-access-prompt-flag.title-reminder",
        defaultMessage: "Your team is working in {product}"
    },
    titleNotInterested: {
        id: "cross-join-nudges.request-access-prompt-flag.title-not-interested",
        defaultMessage: "Your team is waiting for you in {product}"
    },
    descriptionJira: {
        id: "cross-join-nudges.request-access-prompt-flag.description-jira",
        defaultMessage: "Stay on top of your tasks, unify your project workflow and track your team progress in Jira."
    },
    joinButton: {
        id: "cross-join-nudges.request-access-prompt-flag.join-button",
        defaultMessage: "Join your team"
    },
    remindMeLaterButton: {
        id: "cross-join-nudges.request-access-prompt-flag.remind-me-later-button",
        defaultMessage: "Remind me later"
    },
    notInterestedButton: {
        id: "cross-join-nudges.request-access-prompt-flag.not-interested-button",
        defaultMessage: "Not interested"
    },
    titleJpdNudge: {
        id: "cross-join-nudges.request-access-prompt-flag.title-jpd-nudge",
        defaultMessage: "Join your team in using Jira Product Discovery"
    },
    titleJiraNudgeMsr: {
        id: "cross-join-nudges.request-access-prompt-flag.title-jira-nudge",
        defaultMessage: "Join your team in using Jira"
    },
    descriptionJpdNudge: {
        id: "cross-join-nudges.request-access-prompt-flag.description-jpd-nudge",
        defaultMessage: "Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery."
    },
    getStartedButton: {
        id: "cross-join-nudges.request-access-prompt-flag.get-started-button",
        defaultMessage: "Get started"
    },
    doNotShowAgainButton: {
        id: "cross-join-nudges.request-access-prompt-flag.do-not-show-again-button",
        defaultMessage: "Don't show again"
    },
    descriptionJiraGalaxia: {
        id: "cross-join-nudges.request-access-prompt-flag.description-jira-galaxia",
        defaultMessage: "Stay on top of your tasks, unify your space workflow and track your team progress in Jira."
    },
    titleJiraConfluenceMsrNudge: {
        id: "cross-join-nudges.common.request-access-prompt-flag.title-jira-confluence-msr-nudge",
        defaultMessage: "Join your team in using Confluence"
    },
    descriptionJiraConfluenceMsrNudgeNoCollaborators: {
        id: "cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-no-collaborators",
        defaultMessage: "Create project pages to build a shared understanding for better decision-making."
    },
    descriptionJiraConfluenceMsrNudgeWithCollaborators: {
        id: "cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-with-collaborators",
        defaultMessage: "Organize team knowledge, capture ideas, and share requirements for your Jira projects. "
    },
    titleLoomNudge: {
        id: "cross-join-nudges.request-access-prompt-flag.title-loom-nudge",
        defaultMessage: "Join your team on Loom"
    },
    descriptionLoomNudge: {
        id: "cross-join-nudges.request-access-prompt-flag.description-loom-nudge",
        defaultMessage: "Use Loom videos to summarize pages and share information."
    }
});


const $1d9396e15920aa6e$var$messageLibrary = (()=>({
        crossJoinNudgesV3: {
            ctaButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).joinButton,
            remindMeLaterButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).remindMeLaterButton,
            optOutButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).notInterestedButton,
            descriptionWithCollaborators: (0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJiraGalaxia : (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJira,
            descriptionWithoutCollaborators: (0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJiraGalaxia : (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJira,
            title: (0, $69f23a7fc0e94082$export$defe85febe8b728c).title,
            titleReminder: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleReminder,
            titleNotInterested: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleNotInterested
        },
        crossJoinNudgesConfluenceToJpd: {
            ctaButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).getStartedButton,
            remindMeLaterButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).remindMeLaterButton,
            optOutButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).doNotShowAgainButton,
            descriptionWithCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJpdNudge,
            descriptionWithoutCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJpdNudge,
            title: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJpdNudge,
            titleReminder: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJpdNudge,
            titleNotInterested: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJpdNudge
        },
        crossJoinNudgesJiraToConfluence: {
            ctaButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).getStartedButton,
            optOutButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).remindMeLaterButton,
            descriptionWithCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJiraConfluenceMsrNudgeWithCollaborators,
            descriptionWithoutCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJiraConfluenceMsrNudgeNoCollaborators,
            title: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJiraConfluenceMsrNudge,
            titleReminder: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJiraConfluenceMsrNudge,
            titleNotInterested: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJiraConfluenceMsrNudge
        },
        crossJoinNudgesJiraToJpd: {
            ctaButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).getStartedButton,
            optOutButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).remindMeLaterButton,
            descriptionWithCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJpdNudge,
            descriptionWithoutCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJpdNudge,
            title: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJpdNudge,
            titleReminder: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJpdNudge,
            titleNotInterested: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJpdNudge
        },
        crossJoinNudgesConfluenceToJiraMsr: {
            ctaButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).getStartedButton,
            optOutButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).remindMeLaterButton,
            descriptionWithCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJira,
            descriptionWithoutCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJira,
            title: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJiraNudgeMsr,
            titleReminder: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJiraNudgeMsr,
            titleNotInterested: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJiraNudgeMsr
        },
        crossJoinNudgesConfluenceToJpdMsr: {
            ctaButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).getStartedButton,
            optOutButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).doNotShowAgainButton,
            descriptionWithCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJpdNudge,
            descriptionWithoutCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJpdNudge,
            title: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJpdNudge,
            titleReminder: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJpdNudge,
            titleNotInterested: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleJpdNudge
        },
        crossJoinNudgesConfluenceToLoom: {
            ctaButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).getStartedButton,
            remindMeLaterButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).remindMeLaterButton,
            optOutButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).notInterestedButton,
            descriptionWithCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionLoomNudge,
            descriptionWithoutCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionLoomNudge,
            title: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleLoomNudge,
            titleReminder: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleLoomNudge,
            titleNotInterested: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleLoomNudge
        },
        invitedAppShortcuts: {
            ctaButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).joinButton,
            optOutButton: (0, $69f23a7fc0e94082$export$defe85febe8b728c).notInterestedButton,
            descriptionWithCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJira,
            descriptionWithoutCollaborators: (0, $69f23a7fc0e94082$export$defe85febe8b728c).descriptionJira,
            title: (0, $69f23a7fc0e94082$export$defe85febe8b728c).title,
            titleReminder: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleReminder,
            titleNotInterested: (0, $69f23a7fc0e94082$export$defe85febe8b728c).titleNotInterested
        }
    }))();
const $1d9396e15920aa6e$var$MAX_NUMBER_OF_COLLABORATORS = 10;
const $1d9396e15920aa6e$var$styles = {
    descriptionWrapper: "_4bt5LAYvD1 _2WAcuGYvD1 _2YLqiKPgdg _313842Pgdg _1DCdHi2ADO"
};
const $1d9396e15920aa6e$export$5a4ad4945410eb2c = ({ integration: integration, collaborators: collaborators, descriptionWithCollaborators: descriptionWithCollaborators = null, targetProduct: targetProduct, viewCount: viewCount, onSubmit: onSubmit, onDismiss: onDismiss, onSnoozeAndDismiss: onSnoozeAndDismiss, onOptoutAndDismiss: onOptoutAndDismiss, flagComponent: FlagComponent = (0, $FKQbh.default), ...props })=>{
    const handleOnSubmit = (0, $cozmU.useCallback)(async ()=>{
        await onSubmit();
    }, [
        onSubmit
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const messages = $1d9396e15920aa6e$var$messageLibrary[integration];
    const customFlagFooterProps = (0, $cozmU.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jEK83)))
                }
            ],
            linkComponent: ()=>{
                let secondCTA = null;
                if (viewCount === 1 && messages['remindMeLaterButton']) secondCTA = /*#__PURE__*/ $cozmU.createElement((0, $909efa727c14d75b$export$29d11c0fe2fc51d8), {
                    onClick: onSnoozeAndDismiss
                }, formatMessage(messages['remindMeLaterButton']));
                else if (viewCount > 1) secondCTA = /*#__PURE__*/ $cozmU.createElement((0, $909efa727c14d75b$export$29d11c0fe2fc51d8), {
                    onClick: onOptoutAndDismiss
                }, formatMessage(messages['optOutButton']));
                return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                    alignInline: "start",
                    grow: "fill",
                    alignBlock: "center",
                    separator: "\xb7",
                    space: "space.150"
                }, /*#__PURE__*/ $cozmU.createElement((0, $909efa727c14d75b$export$29d11c0fe2fc51d8), {
                    onClick: handleOnSubmit
                }, formatMessage(messages['ctaButton'])), secondCTA);
            }
        }), [
        viewCount,
        handleOnSubmit,
        formatMessage,
        messages,
        onSnoozeAndDismiss,
        onOptoutAndDismiss
    ]);
    const customIcon = (0, $cozmU.useMemo)(()=>{
        return collaborators.length > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $4b57740a6d1321ca$export$29beada2d5f93289), {
            position: "top",
            data: collaborators.slice(0, $1d9396e15920aa6e$var$MAX_NUMBER_OF_COLLABORATORS).map((user)=>({
                    name: user.name,
                    src: user.avatar,
                    appearance: 'circle'
                })),
            boundariesElement: "scrollParent",
            size: "small"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            color: "var(--ds-icon-information, #357DE8)",
            label: ""
        });
    }, [
        collaborators
    ]);
    const title = viewCount === 0 ? messages['title'] : viewCount === 1 ? messages['titleReminder'] : messages['titleNotInterested'];
    const infoFlagTitle = formatMessage(title, {
        product: (0, $fd9fd199a3b7c9b9$export$44fea6589b7ddc92)(targetProduct)
    });
    const description = collaborators.length === 0 ? formatMessage(messages['descriptionWithoutCollaborators']) : descriptionWithCollaborators || formatMessage(messages['descriptionWithCollaborators']);
    return /*#__PURE__*/ $cozmU.createElement(FlagComponent, {
        ...props,
        ...customFlagFooterProps,
        onDismissed: viewCount === 0 ? onDismiss : onSnoozeAndDismiss,
        title: infoFlagTitle,
        description: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $1d9396e15920aa6e$var$styles.descriptionWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "p",
            maxLines: 3
        }, description)),
        icon: customIcon
    });
};
const $1d9396e15920aa6e$export$9b8813c3601640da = (0, $36b44e2fc0c3140b$export$2a4cd3780f93f2ef)($1d9396e15920aa6e$export$5a4ad4945410eb2c);












var $chu6R = parcelRequire("chu6R");





const $133514e84a25c5d2$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "cross-join-nudges.request-access-success-flag.title",
        defaultMessage: "A request was sent to your admins"
    },
    description: {
        id: "cross-join-nudges.request-access-success-flag.description",
        defaultMessage: "You'll receive an email once they've reviewed it."
    }
});


const $36514869cf5df229$export$567128fc1024c9cf = (0, $36b44e2fc0c3140b$export$2a4cd3780f93f2ef)(({ onDismiss: onDismiss, flagComponent: FlagComponent = (0, $FKQbh.default), ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FlagComponent, {
        ...props,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            spacing: "spacious",
            label: "Success",
            color: "var(--ds-icon-success, #6A9A23)"
        }),
        onDismissed: onDismiss,
        title: formatMessage((0, $133514e84a25c5d2$export$defe85febe8b728c).title),
        description: formatMessage((0, $133514e84a25c5d2$export$defe85febe8b728c).description)
    });
});



var $67Ism = parcelRequire("67Ism");


var $lsxnT = parcelRequire("lsxnT");


var $1Hbkf = parcelRequire("1Hbkf");


var $biOtS = parcelRequire("biOtS");

const $5ef7c2e23b8af61a$var$crossJoinRoutes = {
    crossJoinNudgesV3: '/jira',
    crossJoinNudgesConfluenceToJpd: '/jira/projects'
};
const $5ef7c2e23b8af61a$export$e55a23675aaa8cd1 = async ({ product: product, integration: integration, userId: userId, cloudId: cloudId, collaborators: collaborators, createAnalyticsEvent: createAnalyticsEvent, flags: flags, pushRoute: pushRoute, onDisplayed: onDisplayed })=>{
    const featureVisitedCount = (0, $1Hbkf.getFeatureVisitedCount)(integration);
    const attributes = {
        collaborators: collaborators.length,
        userId: userId,
        featureVisitedCount: featureVisitedCount
    };
    const analytics = (0, $biOtS.getExperimentAnalytics)(integration, createAnalyticsEvent, {
        attributes: attributes
    });
    const dismiss = async (id, flags)=>{
        (0, $biOtS.fireFlagDismissed)(analytics);
        await flags.hideFlag(id);
    };
    const dismissAndSnooze = async (id, flags)=>{
        await dismiss(id, flags);
        (0, $biOtS.fireFlagSnoozed)(analytics);
        (0, $1Hbkf.snoozeFeatureFor30Days)(integration);
    };
    const dismissAndOptout = async (id, flags)=>{
        await dismiss(id, flags);
        (0, $biOtS.fireUserOptedOut)(analytics);
        (0, $1Hbkf.setUserOptedOut)(integration);
    };
    // Analytics parity (PUMA-1934): when the choreographer fix is active, `onDisplayed`
    // is supplied and we defer the "flag shown" analytics until the flag is actually
    // displayed (i.e. not blocked by the orchestrator). When it is absent (fix off),
    // retain the previous eager behaviour below.
    const handleDisplayed = onDisplayed ? ()=>{
        (0, $biOtS.fireFlagShown)(analytics);
        onDisplayed();
    } : undefined;
    await flags.showFlag({
        customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ef7c2e23b8af61a$export$ef75ccc59458e1ea, {
                id: props.id,
                integration: integration,
                collaborators: collaborators,
                targetProduct: product,
                viewCount: featureVisitedCount,
                onDisplayed: handleDisplayed,
                onDismiss: ()=>dismiss(props.id, flags),
                onSnoozeAndDismiss: ()=>dismissAndSnooze(props.id, flags),
                onOptoutAndDismiss: ()=>dismissAndOptout(props.id, flags),
                onSubmit: async ()=>{
                    try {
                        const accessStatus = await (0, $67Ism.requestAccess)(product, 'confluence', integration, userId, cloudId, createAnalyticsEvent);
                        if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') pushRoute($5ef7c2e23b8af61a$var$crossJoinRoutes[integration]);
                        else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') {
                            await flags.hideFlag(props.id);
                            await $5ef7c2e23b8af61a$export$fef8478a2c810f18(flags);
                        } else {
                            await flags.hideFlag(props.id);
                            await $5ef7c2e23b8af61a$export$dfa2148cdb92917d(flags, product);
                        }
                    } catch  {
                        await flags.hideFlag(props.id);
                        await $5ef7c2e23b8af61a$export$dfa2148cdb92917d(flags, product);
                    }
                    (0, $biOtS.fireJoinButtonClicked)(analytics);
                }
            })
    });
    // When the fix is off (no onDisplayed), fire eagerly as before. When on, this is
    // fired from handleDisplayed once the flag is actually displayed.
    if (!handleDisplayed) (0, $biOtS.fireFlagShown)(analytics);
};
const $5ef7c2e23b8af61a$export$fef8478a2c810f18 = async (flags)=>{
    await flags.showFlag({
        customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $36514869cf5df229$export$567128fc1024c9cf), {
                id: props.id,
                onDismiss: ()=>flags.hideFlag(props.id)
            })
    });
};
const $5ef7c2e23b8af61a$export$dfa2148cdb92917d = async (flags, product)=>{
    await flags.showFlag({
        customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $753d7ede47f8ecd1$export$e1d0d64874873c8b), {
                id: props.id,
                targetProduct: product,
                onDismiss: ()=>flags.hideFlag(props.id)
            })
    });
};
function $5ef7c2e23b8af61a$export$ef75ccc59458e1ea({ onDisplayed: onDisplayed, ...passThrough }) {
    const { useChoreographedRender: useChoreographedRender } = (0, $lsxnT.useChoreographerAssets)();
    const canShow = useChoreographedRender({
        messageId: 'cc-cross-join-nudge'
    });
    (0, $cozmU.useEffect)(()=>{
        if (canShow) onDisplayed?.();
    }, [
        canShow,
        onDisplayed
    ]);
    return canShow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d9396e15920aa6e$export$9b8813c3601640da), passThrough) : null;
}
module.exports["showNudgeFlag"] = $5ef7c2e23b8af61a$export$e55a23675aaa8cd1;
module.exports["ChoreographerRequestAccessPromptFlag"] = $5ef7c2e23b8af61a$export$ef75ccc59458e1ea;
module.exports["showSuccessFlag"] = $5ef7c2e23b8af61a$export$fef8478a2c810f18;
module.exports["showErrorFlag"] = $5ef7c2e23b8af61a$export$dfa2148cdb92917d;

});

parcelRegister("i1t43", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0WKd3G4z3T",
    baseT26Shape: "_0bjKvDcjp5",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMM7Tp _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbkAwSC",
    defaultAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHswLo _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIswLo _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDGiy _0CMRbkAwSC",
    subtleAppearance: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzZpcK _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbky7kJ",
    subtleAppearanceMotion: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHswLo _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIswLo _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDGiy _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMe5R3 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbke5R3",
    inverseAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHswLo _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIswLo _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDGiy _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $7e44050607850249$var$styles.baseT26Shape, appearance === "default" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === "subtle" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === "inverse" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== target || $[10] !== testId) {
        t3 = target === "_blank" && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`
        }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            className: (0, $hekY6.default)([
                "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
            fill: "currentColor"
        })));
        $[9] = target;
        $[10] = testId;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== children || $[13] !== htmlAttributes || $[14] !== newWindowLabel || $[15] !== ref || $[16] !== t2 || $[17] !== t3 || $[18] !== target || $[19] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t2,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel
        }, children, t3);
        $[12] = children;
        $[13] = htmlAttributes;
        $[14] = newWindowLabel;
        $[15] = ref;
        $[16] = t2;
        $[17] = t3;
        $[18] = target;
        $[19] = testId;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $7e44050607850249$var$styles.baseT26Shape, appearance === 'default' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $7e44050607850249$var$styles.iconWrapper,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $hekY6.default)([
            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("64VTj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fKN6m = parcelRequire("fKN6m");


var $471nw = parcelRequire("471nw");

const $8ae958986c8c799d$var$IntlMessagesProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $8ae958986c8c799d$export$2e2bcd8739ae039 = $8ae958986c8c799d$var$IntlMessagesProvider;
module.exports["default"] = $8ae958986c8c799d$export$2e2bcd8739ae039;

});

parcelRegister("fKN6m", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ezgjU = parcelRequire("ezgjU");

const $8781597542fb3a9a$export$4d17e2d9c5348842 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $bDgLe.c)(4);
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $8781597542fb3a9a$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    (0, $cozmU.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $8781597542fb3a9a$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $8781597542fb3a9a$export$4d17e2d9c5348842;

});

parcelRegister("ezgjU", function(module, exports) {
const $c69670c8f17f7b27$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $c69670c8f17f7b27$export$79618bef82c02d4c;

});

parcelRegister("471nw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ezgjU = parcelRequire("ezgjU");

// Prevents memory leaks
const $2a38add47fc8c1ad$var$cache = (0, $kSwu1.createIntlCache)();
const $2a38add47fc8c1ad$export$f752ac21ea3960a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) return (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $2a38add47fc8c1ad$export$f752ac21ea3960a5;

});

parcelRegister("f95Dj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0f2c84f88927a58d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $0f2c84f88927a58d$export$2e2bcd8739ae039 = {
    'navigation.error.description.default': 'Refresh the page and try again',
    'navigation.error.header.default': "We couldn\u2019t load this content",
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': 'Analytics',
    'navigation.global-shortcuts.apps.assets': 'Assets',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Company Hub',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.customer-service-management': 'Customer Service Management',
    'navigation.global-shortcuts.apps.feedback': 'Feedback',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': 'Goals',
    'navigation.global-shortcuts.apps.home': 'Home',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projects',
    'navigation.global-shortcuts.apps.projects-galaxia': 'Spaces',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Teams',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.error.description': 'Refresh the page and try again',
    'navigation.global-shortcuts.error.header': "We couldn\u2019t load the shortcut for {menuId}",
    'navigation.global-shortcuts.shortcut-action.open-menu-label': 'open menu',
    'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
    'navigation.global-shortcuts.view-all-apps.label': 'View all apps'
};

});

parcelRegister("5Oxbb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $3cd8c709620562fc$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $3fdd79b2df55f4e4$export$2e2bcd8739ae039 = {
    'cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-no-collaborators': 'Create project pages to build a shared understanding for better decision-making.',
    'cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-with-collaborators': 'Organize team knowledge, capture ideas, and share requirements for your Jira projects.',
    'cross-join-nudges.common.request-access-prompt-flag.title-jira-confluence-msr-nudge': 'Join your team in using Confluence',
    'cross-join-nudges.invited-app-shortcuts.confluence': 'Confluence',
    'cross-join-nudges.invited-app-shortcuts.invited-lozenge': 'Invited',
    'cross-join-nudges.invited-app-shortcuts.jira': 'Jira',
    'cross-join-nudges.invited-app-shortcuts.popup-accept-invite-button': 'Accept invite',
    'cross-join-nudges.invited-app-shortcuts.popup-collaborators-tooltip': '{numberOfCollaborators} more {numberOfCollaborators, plural, one {teammate} other {teammates}} are using {app}',
    'cross-join-nudges.invited-app-shortcuts.popup-main-text-with-collaborators': "You're invited to join your team",
    'cross-join-nudges.invited-app-shortcuts.popup-main-text-without-collaborators': "Don't lose access, accept invite now",
    'cross-join-nudges.request-access-error-flag.description-support-link': "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
    'cross-join-nudges.request-access-error-flag.title': "We couldn't add you to {product}",
    'cross-join-nudges.request-access-prompt-flag.description-jira': 'Stay on top of your tasks, unify your project workflow and track your team progress in Jira.',
    'cross-join-nudges.request-access-prompt-flag.description-jira-galaxia': 'Stay on top of your tasks, unify your space workflow and track your team progress in Jira.',
    'cross-join-nudges.request-access-prompt-flag.description-jpd-nudge': 'Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery.',
    'cross-join-nudges.request-access-prompt-flag.description-loom-nudge': 'Use Loom videos to summarize pages and share information.',
    'cross-join-nudges.request-access-prompt-flag.do-not-show-again-button': "Don't show again",
    'cross-join-nudges.request-access-prompt-flag.get-started-button': 'Get started',
    'cross-join-nudges.request-access-prompt-flag.join-button': 'Join your team',
    'cross-join-nudges.request-access-prompt-flag.not-interested-button': 'Not interested',
    'cross-join-nudges.request-access-prompt-flag.remind-me-later-button': 'Remind me later',
    'cross-join-nudges.request-access-prompt-flag.title': 'Your team is now using {product}',
    'cross-join-nudges.request-access-prompt-flag.title-jira-nudge': 'Join your team in using Jira',
    'cross-join-nudges.request-access-prompt-flag.title-jpd-nudge': 'Join your team in using Jira Product Discovery',
    'cross-join-nudges.request-access-prompt-flag.title-loom-nudge': 'Join your team on Loom',
    'cross-join-nudges.request-access-prompt-flag.title-not-interested': 'Your team is waiting for you in {product}',
    'cross-join-nudges.request-access-prompt-flag.title-reminder': 'Your team is working in {product}',
    'cross-join-nudges.request-access-success-flag.description': "You'll receive an email once they've reviewed it.",
    'cross-join-nudges.request-access-success-flag.title': 'A request was sent to your admins'
};


var $3cd8c709620562fc$export$2e2bcd8739ae039 = (0, $3fdd79b2df55f4e4$export$2e2bcd8739ae039);

});

parcelRegister("6uNie", function(module, exports) {

let $4babc804f35ebd22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4babc804f35ebd22$var$load("f5nua").then(()=>parcelRequire('3k94K'));

});

parcelRegister("6cQbT", function(module, exports) {

let $484c591011141b81$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $484c591011141b81$var$load("32h1F").then(()=>parcelRequire('5pqB5'));

});

parcelRegister("72aOG", function(module, exports) {

let $51f11c36ed7acbb4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51f11c36ed7acbb4$var$load("8IfTj").then(()=>parcelRequire('LejDR'));

});

parcelRegister("bdD5z", function(module, exports) {

let $82af3ad743cc0e8e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $82af3ad743cc0e8e$var$load("llV6f").then(()=>parcelRequire('6whkm'));

});

parcelRegister("21tbY", function(module, exports) {

let $179251bb41acb71c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $179251bb41acb71c$var$load("bG7rd").then(()=>parcelRequire('eDU2d'));

});

parcelRegister("k6Zzx", function(module, exports) {

let $ea442126d83510b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ea442126d83510b8$var$load("8NdX9").then(()=>parcelRequire('aKd81'));

});

parcelRegister("c37Dw", function(module, exports) {

let $8c5bb04e09502b4c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c5bb04e09502b4c$var$load("24P2t").then(()=>parcelRequire('4pkGM'));

});

parcelRegister("8Q9xo", function(module, exports) {

let $66fa940d3a93257d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $66fa940d3a93257d$var$load("hosxL").then(()=>parcelRequire('j9omF'));

});

parcelRegister("gGKzJ", function(module, exports) {

let $c264b27664d57b0f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c264b27664d57b0f$var$load("7U7Bd").then(()=>parcelRequire('hQ6pM'));

});

parcelRegister("6czGb", function(module, exports) {

let $483f8a41f94d60b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $483f8a41f94d60b8$var$load("819wQ").then(()=>parcelRequire('bv6J2'));

});

parcelRegister("2p4st", function(module, exports) {

let $1c015fdd8b6399ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c015fdd8b6399ae$var$load("i8YBm").then(()=>parcelRequire('iRaiy'));

});

parcelRegister("g0V0w", function(module, exports) {

let $ba88ddeccac2c595$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba88ddeccac2c595$var$load("fQCLp").then(()=>parcelRequire('2wq7g'));

});

parcelRegister("i49cs", function(module, exports) {

let $d26fbca043a89195$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d26fbca043a89195$var$load("81Onp").then(()=>parcelRequire('7sSHR'));

});

parcelRegister("hh0LP", function(module, exports) {

let $c9349f2a4a7f8c17$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9349f2a4a7f8c17$var$load("2YroX").then(()=>parcelRequire('jLCg2'));

});

parcelRegister("4wFLD", function(module, exports) {

let $34ba8cb3c6f6a92b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $34ba8cb3c6f6a92b$var$load("kp56M").then(()=>parcelRequire('dQEgP'));

});

parcelRegister("krd9P", function(module, exports) {

let $ee108917eb3dc9e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee108917eb3dc9e7$var$load("5Q1F0").then(()=>parcelRequire('cefcn'));

});

parcelRegister("cHRau", function(module, exports) {

let $9402be436e6934ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9402be436e6934ab$var$load("9YLBx").then(()=>parcelRequire('i7Vbl'));

});

parcelRegister("4Do55", function(module, exports) {

let $35fd7bf358a6ff58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35fd7bf358a6ff58$var$load("4foXT").then(()=>parcelRequire('el7dO'));

});

parcelRegister("1F4sI", function(module, exports) {

let $135d14df664d046a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $135d14df664d046a$var$load("33KII").then(()=>parcelRequire('dkV2D'));

});

parcelRegister("8X4YJ", function(module, exports) {

let $6847b20c8a63164f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6847b20c8a63164f$var$load("5cJur").then(()=>parcelRequire('bEtHi'));

});

parcelRegister("80mgK", function(module, exports) {

let $5d3f9901a98cb741$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5d3f9901a98cb741$var$load("7sgez").then(()=>parcelRequire('7jvkV'));

});

parcelRegister("l5HJG", function(module, exports) {

let $f5abfda3e496a3b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f5abfda3e496a3b7$var$load("fYuI4").then(()=>parcelRequire('1YNoI'));

});

parcelRegister("954mw", function(module, exports) {

let $69c7f6eb89f83034$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $69c7f6eb89f83034$var$load("dv58Y").then(()=>parcelRequire('leBA1'));

});

parcelRegister("6XRgG", function(module, exports) {

let $512192ae65855303$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $512192ae65855303$var$load("94GOy").then(()=>parcelRequire('84QZh'));

});

parcelRegister("1u8h5", function(module, exports) {

let $114f02f6cfd0c862$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $114f02f6cfd0c862$var$load("cwjU2").then(()=>parcelRequire('9jPbW'));

});

parcelRegister("cdH9i", function(module, exports) {

let $8e582b6ea9a8e7d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e582b6ea9a8e7d1$var$load("33Iaa").then(()=>parcelRequire('iQHLF'));

});

parcelRegister("cz9pu", function(module, exports) {

let $92600d98edd1e6f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $92600d98edd1e6f5$var$load("6681T").then(()=>parcelRequire('gtKLT'));

});

parcelRegister("jd6mw", function(module, exports) {

let $dfc42aa6afb9523e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfc42aa6afb9523e$var$load("6Hcvs").then(()=>parcelRequire('Q08Xs'));

});

parcelRegister("7jvTN", function(module, exports) {

let $55330d347e9e470e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $55330d347e9e470e$var$load("d3Phe").then(()=>parcelRequire('1Zr5g'));

});

parcelRegister("3dSeZ", function(module, exports) {

let $258ca913bcb466de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $258ca913bcb466de$var$load("3Yk1e").then(()=>parcelRequire('kD6IM'));

});

parcelRegister("acRdm", function(module, exports) {

let $76e44dab05e6df25$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76e44dab05e6df25$var$load("ajzkj").then(()=>parcelRequire('86yOk'));

});

parcelRegister("4cfRQ", function(module, exports) {

let $30e4975656cce2c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $30e4975656cce2c0$var$load("kUZ7k").then(()=>parcelRequire('6mRj0'));

});

parcelRegister("79Hva", function(module, exports) {

let $535b1e33b30196c4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $535b1e33b30196c4$var$load("cDQOq").then(()=>parcelRequire('aQrDE'));

});

parcelRegister("3xT0A", function(module, exports) {

let $294f1fb410425e74$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $294f1fb410425e74$var$load("kLZKK").then(()=>parcelRequire('6T1f4'));

});

parcelRegister("2JjE4", function(module, exports) {

let $1fcf05e74a823b2d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1fcf05e74a823b2d$var$load("33S6H").then(()=>parcelRequire('g6cGH'));

});

parcelRegister("8OdBn", function(module, exports) {

let $669d8b449516be1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $669d8b449516be1b$var$load("93obY").then(()=>parcelRequire('ibWwl'));

});

parcelRegister("bNEyW", function(module, exports) {

let $8973bc3111534bb7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8973bc3111534bb7$var$load("bxfRe").then(()=>parcelRequire('4URgF'));

});

parcelRegister("9DLIE", function(module, exports) {

let $704cc59af3acab9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $704cc59af3acab9f$var$load("1EVcg").then(()=>parcelRequire('39k0K'));

});

parcelRegister("hqvUB", function(module, exports) {

let $cafd9e7249a0a32b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cafd9e7249a0a32b$var$load("28EXy").then(()=>parcelRequire('ggwzT'));

});

parcelRegister("5yUny", function(module, exports) {

let $40cbdc6b0f82b86e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $40cbdc6b0f82b86e$var$load("gg8tK").then(()=>parcelRequire('4oCZG'));

});

parcelRegister("bOdwX", function(module, exports) {

let $898edc1b4166c09b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $898edc1b4166c09b$var$load("fu25G").then(()=>parcelRequire('gtNck'));

});

parcelRegister("fQzFJ", function(module, exports) {

let $b8976215e305fd16$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8976215e305fd16$var$load("cyTsc").then(()=>parcelRequire('56Jqj'));

});

parcelRegister("ghLcq", function(module, exports) {

let $bdb2d8b4412c31c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bdb2d8b4412c31c2$var$load("4TdLB").then(()=>parcelRequire('j8uiO'));

});

parcelRegister("kKATp", function(module, exports) {

let $f1b4b8a1a3228c71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1b4b8a1a3228c71$var$load("dkKxo").then(()=>parcelRequire('k72H4'));

});

parcelRegister("htZTG", function(module, exports) {

let $cba52895835f17f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cba52895835f17f7$var$load("hUWr2").then(()=>parcelRequire('5sMaG'));

});

parcelRegister("jIPaw", function(module, exports) {

let $e5b9d16ac2beb8fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e5b9d16ac2beb8fd$var$load("fgPWL").then(()=>parcelRequire('dA11p'));

});

parcelRegister("8ep6a", function(module, exports) {

let $5fe3199658d7a503$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5fe3199658d7a503$var$load("lWBlc").then(()=>parcelRequire('87C67'));

});

parcelRegister("27H1Y", function(module, exports) {

let $18bd9d3fbff39997$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18bd9d3fbff39997$var$load("kke1I").then(()=>parcelRequire('3Epem'));

});

parcelRegister("67Ism", function(module, exports) {
const $e70e1de8a3e3cc78$export$cd9e5995821603e1 = async (product, sourceProduct, integration, userId, cloudId, createAnalyticsEvent)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    try {
        const response = await fetch('/gateway/api/invitations/v1/access-requests/request', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource,
                metadata: {
                    touchpoint: 'Crossjoin Nudge',
                    sourceProduct: sourceProduct
                }
            })
        });
        const accessRequestResponse = await response.json();
        const { results: results } = accessRequestResponse;
        const result = results[resource];
        const analyticsAttributes = {
            userId: userId,
            products: [
                product
            ],
            inviteResult: [
                {
                    resourceAri: resource,
                    status: result
                }
            ],
            integration: integration
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'requested',
                actionSubject: 'productAccess',
                source: integration,
                attributes: analyticsAttributes
            }
        }).fire();
        return result;
    } catch (error) {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'requestAccess',
                source: integration,
                attributes: {
                    message: String(error),
                    details: {
                        ...error || {}
                    }
                }
            }
        }).fire();
        throw error;
    }
};
module.exports["requestAccess"] = $e70e1de8a3e3cc78$export$cd9e5995821603e1;

});

parcelRegister("lsxnT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $cozmU.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $cozmU.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $cozmU.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("1Hbkf", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $fe3e94e79d9de90d$var$EXPIRY_IN_7_DAYS = 604800;
const $fe3e94e79d9de90d$var$EXPIRY_IN_30_DAYS = 2592000;
const $fe3e94e79d9de90d$export$262c003deb93a450 = async (integration)=>{
    try {
        if ($fe3e94e79d9de90d$export$ee4ac5fe77f8084a(integration)) return true;
        $fe3e94e79d9de90d$export$7a91674e4b755c4b(integration);
        if (!$fe3e94e79d9de90d$export$ee4ac5fe77f8084a(integration)) return true;
        return false;
    } catch  {
        return true;
    }
};
const $fe3e94e79d9de90d$export$64c6861c3bbd89a2 = (integration)=>{
    const value = (0, $17wUi.confluenceLocalStorageInstance).getItem($fe3e94e79d9de90d$var$getVisitedCountStorageKey(integration));
    return parseInt(value, 10) || 0;
};
const $fe3e94e79d9de90d$export$41554dcbb74e65ef = (integration)=>{
    const currentCount = $fe3e94e79d9de90d$export$64c6861c3bbd89a2(integration);
    (0, $17wUi.confluenceLocalStorageInstance).setItem($fe3e94e79d9de90d$var$getVisitedCountStorageKey(integration), currentCount + 1);
};
const $fe3e94e79d9de90d$export$7a91674e4b755c4b = (integration)=>{
    $fe3e94e79d9de90d$var$setFeatureVisited(integration, $fe3e94e79d9de90d$var$EXPIRY_IN_7_DAYS);
};
const $fe3e94e79d9de90d$export$788659dbff920e5f = (integration)=>{
    $fe3e94e79d9de90d$var$setFeatureVisited(integration, $fe3e94e79d9de90d$var$EXPIRY_IN_30_DAYS);
};
const $fe3e94e79d9de90d$var$setFeatureVisited = (integration, expire)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem($fe3e94e79d9de90d$var$getVisitedStorageKey(integration), true, expire);
};
const $fe3e94e79d9de90d$export$ee4ac5fe77f8084a = (integration)=>(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean($fe3e94e79d9de90d$var$getVisitedStorageKey(integration));
const $fe3e94e79d9de90d$export$4ceb2f7d0e405037 = (integration)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem($fe3e94e79d9de90d$var$getOptOutStorageKey(integration), true);
};
const $fe3e94e79d9de90d$export$c74d1fb7a364edae = (integration)=>(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean($fe3e94e79d9de90d$var$getOptOutStorageKey(integration));
function $fe3e94e79d9de90d$var$getOptOutStorageKey(integration) {
    switch(integration){
        case 'crossJoinNudgesV3':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_V3_USER_OPT_OUT;
        case 'crossJoinNudgesConfluenceToJpd':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_JPD_USER_OPT_OUT;
        case 'crossJoinNudgesConfluenceToLoom':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_OPT_OUT;
        default:
            return '';
    }
}
function $fe3e94e79d9de90d$var$getVisitedStorageKey(integration) {
    switch(integration){
        case 'crossJoinNudgesV3':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_V3_VISITED_KEY;
        case 'crossJoinNudgesConfluenceToJpd':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_JPD_VISITED_KEY;
        case 'crossJoinNudgesConfluenceToLoom':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_VISITED_KEY;
        default:
            return '';
    }
}
function $fe3e94e79d9de90d$var$getVisitedCountStorageKey(integration) {
    switch(integration){
        case 'crossJoinNudgesV3':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_V3_VISITED_COUNT;
        case 'crossJoinNudgesConfluenceToJpd':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_JPD_VISITED_COUNT;
        case 'crossJoinNudgesConfluenceToLoom':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_VISITED_COUNT;
        default:
            return '';
    }
}
module.exports["isFeatureVisited"] = $fe3e94e79d9de90d$export$262c003deb93a450;
module.exports["getFeatureVisited"] = $fe3e94e79d9de90d$export$ee4ac5fe77f8084a;
module.exports["snoozeFeatureFor7Days"] = $fe3e94e79d9de90d$export$7a91674e4b755c4b;
module.exports["getFeatureVisitedCount"] = $fe3e94e79d9de90d$export$64c6861c3bbd89a2;
module.exports["increaseFeatureVisitedCount"] = $fe3e94e79d9de90d$export$41554dcbb74e65ef;
module.exports["snoozeFeatureFor30Days"] = $fe3e94e79d9de90d$export$788659dbff920e5f;
module.exports["setUserOptedOut"] = $fe3e94e79d9de90d$export$4ceb2f7d0e405037;
module.exports["isUserOptedOut"] = $fe3e94e79d9de90d$export$c74d1fb7a364edae;

});

parcelRegister("biOtS", function(module, exports) {
const $5ce0e61a84ffab65$export$459d2a90e25243eb = 'cross_join_nudges_confluence_to_jpd_experiment';
const $5ce0e61a84ffab65$export$ff0d532025d54d77 = (integration, createAnalyticsEvent, { attributes: commonAttributes = {} } = {})=>(type, actionSubject, action, actionSubjectId, attributes)=>createAnalyticsEvent({
            type: type,
            data: {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                source: integration,
                attributes: {
                    ...commonAttributes,
                    ...attributes
                }
            }
        }).fire();
const $5ce0e61a84ffab65$export$ed26b312f8fb3da = (analytics, error)=>analytics('sendOperationalEvent', 'showCrossJoinNudges', 'failed', undefined, {
        message: String(error),
        details: {
            ...error
        }
    });
const $5ce0e61a84ffab65$export$926c49ee4cec3927 = (analytics)=>analytics('sendUIEvent', 'flag', 'dismissed', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$dfd781a069757128 = (analytics)=>analytics('sendUIEvent', 'flag', 'snoozed', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$b02e37e6448a2f = (analytics)=>analytics('sendUIEvent', 'user', 'optedOut', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$9ca55cf6ee7ca489 = (analytics)=>analytics('sendUIEvent', 'flag', 'shown', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$951f0a85c06c95e8 = (analytics)=>analytics('sendUIEvent', 'joinButton', 'clicked', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$b6a30d1aef42926f = (analytics)=>{
    analytics('sendTrackEvent', 'eligibility', 'checked', undefined, {
        flagKey: 'NON_CONTEXTUAL_CROSS_JOIN_NUDGES',
        ineligibilityReason: 'SITE_OPTED_OUT'
    });
};
const $5ce0e61a84ffab65$export$e19a7f6320c04dee = (analytics, nudgeId)=>{
    analytics('sendTrackEvent', 'eligibility', 'checked', undefined, {
        flagKey: 'NON_CONTEXTUAL_CROSS_JOIN_NUDGES',
        ineligibilityReason: 'MSR_NOT_RECOMMENDED',
        nudgeId: nudgeId
    });
};
const $5ce0e61a84ffab65$export$a303df7e5393c39c = (source, createAnalyticsEvent, { attributes: commonAttributes = {} } = {})=>(type, actionSubject, action, actionSubjectId, attributes)=>createAnalyticsEvent({
            type: type,
            data: {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...commonAttributes,
                    ...attributes
                }
            }
        }).fire();
const $5ce0e61a84ffab65$export$946cc509d91a25c0 = (analytics, error, actionSubject, action, analyticsAttributes)=>analytics('sendOperationalEvent', actionSubject, action, undefined, {
        message: String(error),
        details: error instanceof Error ? {
            ...error
        } : {},
        ...analyticsAttributes
    });
const $5ce0e61a84ffab65$export$ef76abaf7a2fcf22 = (analytics, attributes)=>analytics('sendTrackEvent', 'loomCjnEligibility', 'checked', undefined, attributes);
module.exports["getExperimentAnalytics"] = $5ce0e61a84ffab65$export$ff0d532025d54d77;
module.exports["fireExperimentError"] = $5ce0e61a84ffab65$export$ed26b312f8fb3da;
module.exports["fireFlagDismissed"] = $5ce0e61a84ffab65$export$926c49ee4cec3927;
module.exports["fireFlagSnoozed"] = $5ce0e61a84ffab65$export$dfd781a069757128;
module.exports["fireUserOptedOut"] = $5ce0e61a84ffab65$export$b02e37e6448a2f;
module.exports["fireFlagShown"] = $5ce0e61a84ffab65$export$9ca55cf6ee7ca489;
module.exports["fireJoinButtonClicked"] = $5ce0e61a84ffab65$export$951f0a85c06c95e8;
module.exports["fireSiteOptedOutAnalytics"] = $5ce0e61a84ffab65$export$b6a30d1aef42926f;
module.exports["fireMsrNotRecommendedAnalytics"] = $5ce0e61a84ffab65$export$e19a7f6320c04dee;
module.exports["getCustomExperimentAnalytics"] = $5ce0e61a84ffab65$export$a303df7e5393c39c;
module.exports["fireLoomCjnEligibilityChecked"] = $5ce0e61a84ffab65$export$ef76abaf7a2fcf22;

});

parcelRegister("9CZiz", function(module, exports) {
const $856c7303021bdbe3$export$7663eef720c16d28 = async (product, cloudId, createAnalyticsEvent, source)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    try {
        const response = await fetch(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) {
            // 400 response means the user is not licensed for the product and we want to handle this case so it still caches the result.
            // For other error codes we still want to throw an error so the result is not cached.
            if (response.status === 400) return false;
            else throw new Error(`Unexpected response status: ${response.status}`);
        }
        const capabilities = (await response.json())?.results[resource];
        return capabilities === 'DIRECT_ACCESS' || capabilities === 'REQUEST_ACCESS';
    } catch (err) {
        // Source is required for operational events otherwise it won't fire
        if (createAnalyticsEvent && source) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'fetchError',
                actionSubject: 'capabilitiesCheck',
                source: source,
                attributes: {
                    message: String(err)
                }
            }
        }).fire();
        throw err;
    }
};
module.exports["canUserRequestAccess"] = $856c7303021bdbe3$export$7663eef720c16d28;

});

parcelRegister("1zMDo", function(module, exports) {
const $051a69425a062d46$export$23b7746c9e6ae406 = async (product, cloudId)=>{
    const traitName = $051a69425a062d46$var$ACTIVATION_TRAITS[product] || undefined;
    if (!traitName) throw Error(`Unknown activation trait key for site product ${product}`);
    const siteTraits = await $051a69425a062d46$var$fetchSitePersonalization(cloudId);
    const productActivation = siteTraits.find((trait)=>trait.name === traitName);
    if (productActivation?.value) {
        const oneWeekLaterActivation = new Date(productActivation?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return false;
};
const $051a69425a062d46$export$e7b898c6b427cf14 = async (cloudId)=>{
    const traitName = $051a69425a062d46$var$ACTIVATION_TRAITS['loom'] || undefined;
    if (!traitName) throw Error(`Unknown activation trait key for site product Loom}`);
    const siteTraits = await $051a69425a062d46$var$fetchSitePersonalization(cloudId);
    const productActivation = siteTraits.find((trait)=>trait.name === traitName);
    if (productActivation?.value) {
        const oneWeekLaterActivation = new Date(productActivation?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return true;
};
const $051a69425a062d46$var$ACTIVATION_TRAITS = {
    'jira-software': 'jira-software.ondemand.activationDate',
    'jira-product-discovery': 'jira-product-discovery.activationDate',
    confluence: 'confluence.ondemand.activationDate',
    loom: 'loom.activationDate'
};
const $051a69425a062d46$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $051a69425a062d46$var$fetchSitePersonalization = async (cloudId)=>{
    const response = await fetch($051a69425a062d46$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};
module.exports["isSite7DaysOld"] = $051a69425a062d46$export$23b7746c9e6ae406;
module.exports["isLoomSite7DaysOld"] = $051a69425a062d46$export$e7b898c6b427cf14;

});

parcelRegister("1LmRa", function(module, exports) {
const $d5b6f5c2782bfa86$export$780c542cf1b3e229 = async (product, cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:${product}::site/${cloudId}`
    };
    const response = await fetch('/gateway/api/permissions/permitted', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    return (await response.json()).permitted;
};
module.exports["hasAccessToProduct"] = $d5b6f5c2782bfa86$export$780c542cf1b3e229;

});

parcelRegister("pUzjH", function(module, exports) {
const $70a693612bc9ad24$export$3475487c10c1ac17 = async (cloudId)=>{
    const siteTraits = await $70a693612bc9ad24$var$fetchSitePersonalization(cloudId);
    const optoutTraitValue = siteTraits.find((trait)=>trait.name === 'optout_all_messages')?.value;
    return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};
const $70a693612bc9ad24$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $70a693612bc9ad24$var$fetchSitePersonalization = async (cloudId)=>{
    const response = await fetch($70a693612bc9ad24$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};
module.exports["isSiteOptedOut"] = $70a693612bc9ad24$export$3475487c10c1ac17;

});

parcelRegister("aoPxZ", function(module, exports) {
const $8556bd4e4ff6e3f2$export$9641ccd51cea648b = async (cloudId, userId, trait)=>{
    const requiredDaysActive = 14;
    const userTraits = await $8556bd4e4ff6e3f2$var$fetchUserPersonalization(cloudId, userId);
    const activationDateTrait = userTraits.find((t)=>t.name === trait);
    if (!activationDateTrait || typeof activationDateTrait.value !== 'string') return true;
    const activationDate = new Date(activationDateTrait.value);
    return $8556bd4e4ff6e3f2$export$9b2c7fafd3ba5799(activationDate, requiredDaysActive);
};
const $8556bd4e4ff6e3f2$export$9b2c7fafd3ba5799 = (startDate, thresholdDays)=>{
    const today = new Date();
    const dateAfterThreshold = new Date(startDate);
    dateAfterThreshold.setDate(startDate.getDate() + thresholdDays);
    return today <= dateAfterThreshold;
};
const $8556bd4e4ff6e3f2$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $8556bd4e4ff6e3f2$var$fetchUserPersonalization = async (cloudId, userId)=>{
    const response = await fetch($8556bd4e4ff6e3f2$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};
module.exports["isUserTooNew"] = $8556bd4e4ff6e3f2$export$9641ccd51cea648b;

});

parcelRegister("hYAxW", function(module, exports) {
const $b92c55de156e9a05$var$ONE_DAY_IN_MILLISECONDS = 86400000;
function $b92c55de156e9a05$export$6cca8a222d1193d7() {
    let queue = [];
    let locked = false;
    const acquireLock = ()=>{
        return new Promise((resolve)=>{
            const releaseLock = ()=>{
                locked = false;
                processQueue();
            };
            const grantLock = ()=>{
                locked = true;
                resolve(releaseLock);
            };
            if (locked) queue.push(()=>{
                grantLock();
            });
            else grantLock();
        });
    };
    const processQueue = ()=>{
        if (queue.length > 0) {
            const resolveNextItem = queue.shift();
            if (resolveNextItem) resolveNextItem();
        }
    };
    return {
        acquireLock: acquireLock
    };
}
function $b92c55de156e9a05$export$61c308f36d3fce82(control) {
    const mutex = $b92c55de156e9a05$export$6cca8a222d1193d7();
    function getControlCache() {
        const possibleObject = control.get();
        if (possibleObject === undefined || possibleObject === null || possibleObject === '') return {};
        return possibleObject;
    }
    return {
        get: async (key)=>{
            const releaseLock = await mutex.acquireLock();
            const storedValues = getControlCache();
            const storedCheck = storedValues[key];
            if (storedCheck !== null && storedCheck !== undefined) {
                const { value: { value: value, ttl: ttl } } = storedCheck;
                const pastTtl = ttl ? ttl < Date.now() : false;
                if (pastTtl) {
                    releaseLock();
                    return undefined;
                }
                releaseLock();
                return value;
            }
            releaseLock();
            return undefined;
        },
        set: async (key, value, daysToLive)=>{
            const releaseLock = await mutex.acquireLock();
            const storedValues = getControlCache();
            const keyValue = {
                value: {
                    value: value,
                    ...daysToLive ? {
                        ttl: new Date().getTime() + $b92c55de156e9a05$var$ONE_DAY_IN_MILLISECONDS * daysToLive
                    } : {}
                },
                timestamp: Date.now()
            };
            storedValues[key] = keyValue;
            control.set(storedValues);
            releaseLock();
        },
        delete: async (key)=>{
            const releaseLock = await mutex.acquireLock();
            const object = control.get();
            delete object[key];
            control.set(object);
            releaseLock();
        },
        deleteAll: async ()=>{
            const releaseLock = await mutex.acquireLock();
            control.delete();
            releaseLock();
        }
    };
}
function $b92c55de156e9a05$export$d932b194d241af5e(cache) {
    function withEligibilityCache(key, eligibilityCheck, daysToLive) {
        return async (...args)=>{
            try {
                const cachedValue = await cache.get(key);
                if (cachedValue !== undefined && cachedValue !== null) return cachedValue;
            } catch (e) {
            // cache get fail, do nothing
            }
            const result = await eligibilityCheck(...args);
            try {
                await cache.set(key, result, daysToLive);
            } catch (e) {
            // cache set fail, do nothing
            }
            return result;
        };
    }
    return withEligibilityCache;
}



var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $0ca9c4cacb4d1123$var$cjnEligibilityCacheController = {
    get: ()=>(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_ELIGIBILITY_KEY),
    set: (value)=>(0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_ELIGIBILITY_KEY, value),
    delete: ()=>(0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_ELIGIBILITY_KEY)
};
const $0ca9c4cacb4d1123$export$beb12117dd89482e = (0, $b92c55de156e9a05$export$61c308f36d3fce82)($0ca9c4cacb4d1123$var$cjnEligibilityCacheController);
const $0ca9c4cacb4d1123$export$86938f072bd79cac = (0, $b92c55de156e9a05$export$d932b194d241af5e)($0ca9c4cacb4d1123$export$beb12117dd89482e);
const $0ca9c4cacb4d1123$export$9fafd3f54ebb3132 = {
    get: (key)=>{
        const storedValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY);
        if (!storedValue) return undefined;
        const storedValueObject = JSON.parse(storedValue);
        return storedValueObject[key];
    },
    set: (key, value)=>{
        const storedValue = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY) ?? '{}');
        storedValue[key] = value;
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY, JSON.stringify(storedValue));
    },
    delete: (key)=>{
        const storedValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY) ?? {};
        delete storedValue[key];
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_EVENT_CACHE_KEY, JSON.stringify(storedValue));
    }
};
const $0ca9c4cacb4d1123$export$2a72056994381bc4 = async ()=>{
    await $0ca9c4cacb4d1123$export$beb12117dd89482e.set('local_storage_enabled', true);
    const value = await $0ca9c4cacb4d1123$export$beb12117dd89482e.get('local_storage_enabled');
    return value === true;
};
const $0ca9c4cacb4d1123$export$d172f6d49154a44b = async ()=>{
    try {
        // overwrite the key even if it exists
        await $0ca9c4cacb4d1123$export$beb12117dd89482e.set('has_seen_nudge_in_last_7_days', true);
    } catch (e) {
    // cache set fail, do nothing
    }
};
const $0ca9c4cacb4d1123$export$f03b4069dddacff6 = async ()=>{
    try {
        return !!await $0ca9c4cacb4d1123$export$beb12117dd89482e.get('has_seen_nudge_in_last_7_days');
    } catch (e) {
    // cache get fail, return false
    }
    return false;
};
module.exports["withEligibilityCache"] = $0ca9c4cacb4d1123$export$86938f072bd79cac;
module.exports["cjnLoomEventCacheController"] = $0ca9c4cacb4d1123$export$9fafd3f54ebb3132;
module.exports["isCacheEnabled"] = $0ca9c4cacb4d1123$export$2a72056994381bc4;
module.exports["setHasSeenNudgeInLast7Days"] = $0ca9c4cacb4d1123$export$d172f6d49154a44b;
module.exports["getHasSeenNudgeInLast7Days"] = $0ca9c4cacb4d1123$export$f03b4069dddacff6;

});

parcelRegister("dvzq9", function(module, exports) {

let $9d59a56d0cfb3f8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d59a56d0cfb3f8c$var$load("b2zon").then(()=>parcelRequire('3hjAC'));

});

parcelRegister("7KWaT", function(module, exports) {

let $5a59f4962dd28e18$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a59f4962dd28e18$var$load("bP6pn").then(()=>parcelRequire('iII7v'));

});

parcelRegister("hUiLd", function(module, exports) {

let $d096381afe1e604b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d096381afe1e604b$var$load("7EorR"),
    $d096381afe1e604b$var$load("3Ap7H")
]).then(()=>parcelRequire('hcbgd'));

});

parcelRegister("jiQoC", function(module, exports) {

let $e0d85786164af0cf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e0d85786164af0cf$var$load("gsywu").then(()=>parcelRequire('djl9a'));

});

parcelRegister("4DHPP", function(module, exports) {

let $360ccea7c7cbb383$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $360ccea7c7cbb383$var$load("aPSID").then(()=>parcelRequire('7DERG'));

});

parcelRegister("csHE2", function(module, exports) {

let $9129f47c28c6ce77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9129f47c28c6ce77$var$load("hhss7"),
    $9129f47c28c6ce77$var$load("Wowvf"),
    $9129f47c28c6ce77$var$load("dj3mE")
]).then(()=>parcelRequire('2pYxO'));

});

parcelRegister("kdqYf", function(module, exports) {

let $eb79f15cb03ea0f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $eb79f15cb03ea0f2$var$load("hafZt"),
    $eb79f15cb03ea0f2$var$load("9NRga"),
    $eb79f15cb03ea0f2$var$load("c5pF4"),
    $eb79f15cb03ea0f2$var$load("4evdD"),
    $eb79f15cb03ea0f2$var$load("ktyyJ")
]).then(()=>parcelRequire('1VYG6'));

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("5W8qe", function(module, exports) {
var $4528e6ffac657016$var$has = Object.prototype.hasOwnProperty;
function $4528e6ffac657016$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $4528e6ffac657016$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($4528e6ffac657016$var$has.call(foo, ctor) && ++len && !$4528e6ffac657016$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$4528e6ffac657016$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
module.exports["dequal"] = $4528e6ffac657016$export$de8294bb3be0322f;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});

parcelRegister("dPoYT", function(module, exports) {
const $8dbc220cf14fe789$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal',
    FULL_SCREEN_MODAL: 'full-screen-modal'
};
module.exports["ConversationAssistantUIModes"] = $8dbc220cf14fe789$export$bc36ebf73899a71d;

});

parcelRegister("kQqCc", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $d52db76b74818184$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $d52db76b74818184$export$64aee74ba59709e5 = 439; // px
const $d52db76b74818184$export$1c07393c5bb1bc27 = 439; // px
const $d52db76b74818184$export$aa3478deee7adbeb = 350; // px
const $d52db76b74818184$export$21e515a86cd1733b = 'Chat';
const $d52db76b74818184$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $d52db76b74818184$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $d52db76b74818184$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $d52db76b74818184$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $d52db76b74818184$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $d52db76b74818184$export$e942bf04e23ff966;

});

parcelRegister("2bR8c", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kQqCc = parcelRequire("kQqCc");


var $jln20 = parcelRequire("jln20");

const $da7293b7c8deb7d1$export$c27f18f8bab3d8b9 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const isConversationAssistantSidebarActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
    return (0, $cozmU.useMemo)(()=>{
        return {
            isSidebarOpen: ()=>{
                return isConversationAssistantSidebarActive;
            },
            openSidebar: ()=>{
                rightSidebarContext.open((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
            },
            closeSidebar: ()=>{
                if (isConversationAssistantSidebarActive) rightSidebarContext.close((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID));
            }
        };
    }, [
        isConversationAssistantSidebarActive,
        rightSidebarContext
    ]);
};
module.exports["useCreateRovoExperienceSidebarController"] = $da7293b7c8deb7d1$export$c27f18f8bab3d8b9;

});

parcelRegister("bVAxT", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $kNIYN.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}
module.exports["RestrictionsDialogStateContainer"] = $20c3e8ab10e63e24$export$f91385b453474810;

});

parcelRegister("14SPd", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

var $jIOyV = parcelRequire("jIOyV");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;
module.exports["RESTRICTIONS_DIALOG_METRIC"] = $8ab24ab9418ac89d$export$2ba38536ff91e2a7;

});

parcelRegister("lqy4C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $cozmU.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip,
        __callerPackage__: "storage-enforcement"
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("cLhhP", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $8s9DV.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $kBr4q.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $kBr4q.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("4S8ti", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9HkI0 = parcelRequire("9HkI0");


var $9DHhW = parcelRequire("9DHhW");







// Events
const $614c5c37063965fd$export$38f20466f22f45f0 = 'CLICK_PRIVACY_POLICY_LINK';
const $614c5c37063965fd$export$836f30b3a88d4259 = 'UNDO_DISMISSAL_STARTED';
const $614c5c37063965fd$export$5ee3f53555c01a95 = 'UNDO_DISMISSAL_SUCCEEDED';
const $614c5c37063965fd$export$eebf6a2671000e28 = 'UNDO_DISMISSAL_FAILED';
const $614c5c37063965fd$export$14b7e2c312f27acd = 'atlassian-growth-recos';


function $c1e538033f9a5add$export$a079a83b07f794bf(value) {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if (typeof value === 'object' && Object.keys(value).length === 0) return false;
    return true;
}
function $c1e538033f9a5add$export$31553aaa555c1514(contextResolver, checkUseCase = true) {
    const context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
    if (checkUseCase && (typeof context?.useCase !== 'string' || context?.useCase.trim().length === 0)) throw new Error('useCase is required');
    return context;
}



class $bc1de3a3719fb34a$export$2e2bcd8739ae039 {
    getHeaders() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    }
    getContext(contextResolver) {
        return (0, $c1e538033f9a5add$export$31553aaa555c1514)(contextResolver);
    }
    constructor(endpoint){
        this.endpoint = endpoint;
    }
}


class $33473eb0511f2f3c$export$2e2bcd8739ae039 extends (0, $bc1de3a3719fb34a$export$2e2bcd8739ae039) {
    makeRequest(makeRequestParams) {
        const { contextResolver: contextResolver, first: first, rerank: rerank } = makeRequestParams;
        return new Request(this.endpoint, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: this.getHeaders(),
            body: JSON.stringify({
                query: $33473eb0511f2f3c$var$recommendationsQuery,
                variables: {
                    first: first,
                    context: this.getContext(contextResolver),
                    rerank: rerank
                }
            })
        });
    }
}
const $33473eb0511f2f3c$var$recommendationsQuery = `
query GrowthRecQuery($context: GrowthRecContext!, $first: Int!, $rerank: [GrowthRecRerankCandidate!]) {
  growthRecommendations {
    recommendations(context: $context, first: $first, rerank: $rerank) {
      ... on GrowthRecRecommendations {
        __typename
        data {
          __typename
          entityId
          reasons
        }
      }
      ... on QueryError {
        __typename
        identifier
        message
        extensions {
          __typename
          statusCode
          errorType
        }
      }
    }
  }
}
`;


class $37a46ca6bfe66fc8$export$d0a1abfd57dc5018 {
    constructor(code, reason, response){
        this.code = code;
        this.reason = reason;
        this.response = response;
    }
}
class $37a46ca6bfe66fc8$var$QueryResultCreator {
}
class $37a46ca6bfe66fc8$export$ad7cb7f4450dd7c4 extends $37a46ca6bfe66fc8$var$QueryResultCreator {
    makeQueryResult() {
        return new $37a46ca6bfe66fc8$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText);
    }
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
}
class $37a46ca6bfe66fc8$export$553722ecbbe27276 extends $37a46ca6bfe66fc8$var$QueryResultCreator {
    makeQueryResult() {
        const [{ extensions: extensions }] = this.errors;
        const [{ statusCode: statusCode, errorType: errorType }] = Array.isArray(extensions) ? extensions : [
            extensions
        ];
        return new $37a46ca6bfe66fc8$export$d0a1abfd57dc5018(statusCode, errorType, {
            errors: this.errors.map((error)=>error.message)
        });
    }
    constructor(errors){
        super(), this.errors = errors;
    }
}
class $37a46ca6bfe66fc8$export$ff264bfdc9a404eb extends $37a46ca6bfe66fc8$var$QueryResultCreator {
    makeQueryResult() {
        return new $37a46ca6bfe66fc8$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText, {
            errors: [
                'Received data has missing attributes'
            ]
        });
    }
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
}
class $37a46ca6bfe66fc8$export$6b16771e962990ff extends $37a46ca6bfe66fc8$var$QueryResultCreator {
    constructor(response, data){
        super(), this.response = response, this.data = data;
    }
}


class $df6222145c920e2c$export$c02f0b31b3b527a3 extends (0, $37a46ca6bfe66fc8$export$6b16771e962990ff) {
    makeQueryResult() {
        return new (0, $37a46ca6bfe66fc8$export$d0a1abfd57dc5018)(this.response.status, this.response.statusText, {
            data: this.data
        });
    }
    constructor(response, data){
        super(response, data), this.response = response;
    }
}


class $0dd1b01107e01178$export$7f19312509e0d2c0 {
    extract(response) {
        return response?.recommendations?.data ?? [];
    }
    getSuccessResultCreator(response, result) {
        return new (0, $df6222145c920e2c$export$c02f0b31b3b527a3)(response, result);
    }
}



class $8d6a180bad3220aa$export$2e2bcd8739ae039 {
    async get(request) {
        return undefined;
    }
    async set(request, response) {
        return;
    }
    async delete(request) {
        return true;
    }
}


const $ac701480a68abbdf$var$DEFAULT_TTL = 60;
class $ac701480a68abbdf$export$2e2bcd8739ae039 {
    get cacheName() {
        return this.cacheProviderConfig.cacheName;
    }
    get useCase() {
        return this.cacheProviderConfig.useCase;
    }
    get ttl() {
        return this.cacheProviderConfig.ttl ?? $ac701480a68abbdf$var$DEFAULT_TTL;
    }
    get onError() {
        return this.cacheProviderConfig.onError ?? (()=>{});
    }
    constructor(cacheProviderConfig){
        this.cacheProviderConfig = cacheProviderConfig;
    }
}


class $c1ceaf3ff88564f5$export$2e2bcd8739ae039 {
    /**
   * Set the expiry date of the cached response
   */ async setExpiry(key, expireAt) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.put(expireAt, key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
   * Get the expiry date of the cached response
   */ async getExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readonly');
                const storeRequest = store.get(key);
                storeRequest.onsuccess = ()=>{
                    resolve(Number(storeRequest.result ?? 0));
                };
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    async deleteExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.delete(key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
   * Initialise the IndexedDB
   */ initDb() {
        const dbRequest = indexedDB.open(`${this.cacheConfig.cacheName}-expiry`);
        dbRequest.onupgradeneeded = ()=>{
            const db = dbRequest.result;
            db.createObjectStore(this.expiryStoreName);
        };
        return dbRequest;
    }
    /**
   * Get the object store from the IndexedDB
   */ getObjectStore(dbRequest, mode = 'readwrite') {
        const db = dbRequest.result;
        return db.transaction(this.expiryStoreName, mode).objectStore(this.expiryStoreName);
    }
    /**
   * Initialise the ExpiryStorage
   */ constructor(cacheConfig){
        this.cacheConfig = cacheConfig;
        this.expiryStoreName = 'expiries';
    }
}


class $fa4b8f7da0c6309d$export$2e2bcd8739ae039 {
    /**
   * Get cached response
   */ async get(request) {
        if (!this.supported) return undefined;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expired = await this.isExpired(request);
            if (expired) {
                await this.delete(request);
                return undefined;
            }
            return cache.match(this.getCacheKey(request));
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
   * Put response in cache
   */ async set(request, response) {
        if (!this.supported) return;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expiryDate = Date.now() + this.cacheConfig.ttl * 1000;
            await this.expiryStorage.setExpiry(this.getStoreKey(request), expiryDate);
            await cache.put(this.getCacheKey(request), response);
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
   * Delete cached response
   */ async delete(request) {
        if (!this.supported) return true;
        try {
            return caches.open(this.cacheConfig.cacheName).then(async (cache)=>{
                await cache.delete(this.getCacheKey(request));
                await this.expiryStorage.deleteExpiry(this.getStoreKey(request));
                return true;
            });
        } catch (e) {
            this.cacheConfig.onError(e);
            return false;
        }
    }
    /**
   * Check if the cached response is expired
   */ async isExpired(request) {
        try {
            const key = this.getStoreKey(request);
            const expiry = await this.expiryStorage.getExpiry(key);
            return Date.now() > (expiry ?? 0);
        } catch (error) {
            this.cacheConfig.onError(error instanceof Error ? error : new Error('Error checking expiry'));
            return true;
        }
    }
    /**
   * Compose the URL and the use case as the search params to cache the response
   */ getCacheKey(request) {
        const url = new URL(request.url);
        url.searchParams.set('useCase', this.cacheConfig.useCase);
        return url;
    }
    /**
   * Get the key to store the response
   * Interally, it hashes the request body to get a unique key
   */ getStoreKey(request) {
        return this.getCacheKey(request).toString();
    }
    /**
   * Initialise the WebCacheStorage
   * @param cacheName The name of the cache to use. See {@link https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage/open}
   * @param onError a callback when any error occurs
   */ constructor(cacheProviderConfig){
        /**
     * Whether the Cache API is supported
     */ this.supported = void 0;
        /**
     * Expiry storage
     */ this.expiryStorage = void 0;
        this.cacheConfig = void 0;
        this.supported = typeof caches === 'object' && typeof caches.open === 'function';
        this.cacheConfig = new (0, $ac701480a68abbdf$export$2e2bcd8739ae039)(cacheProviderConfig);
        this.expiryStorage = new (0, $c1ceaf3ff88564f5$export$2e2bcd8739ae039)(this.cacheConfig);
    }
}


class $e5baf61a4d630ec7$export$2e2bcd8739ae039 {
    /**
   * Returns the cache provider based on the given cache configuration
   *
   * @param cacheConfig The cache configuration to use
   * @returns The cache provider
   */ static resolve(cacheConfig) {
        if (cacheConfig) return new (0, $fa4b8f7da0c6309d$export$2e2bcd8739ae039)(cacheConfig);
        return new (0, $8d6a180bad3220aa$export$2e2bcd8739ae039)();
    }
}


class $832d4de619bcc498$export$2e2bcd8739ae039 {
    /**
   * Fetches the response by the given request from the cache or the API
   * the cache config is optional, if not provided, the response will not be cached
   *
   * @param request The request to fetch the response from
   * @param cacheConfig The cache configuration to use
   * @returns The query result
   */ fetch(request, { cacheConfig: cacheConfig } = {}) {
        return new Promise(async (resolve, reject)=>{
            const response = await this.getResponse(request, cacheConfig);
            if (!response.ok) return reject(new (0, $37a46ca6bfe66fc8$export$ad7cb7f4450dd7c4)(response).makeQueryResult());
            const json = await response.json();
            if (json.errors) return reject(new (0, $37a46ca6bfe66fc8$export$553722ecbbe27276)(json.errors).makeQueryResult());
            const schemaResponse = json?.data?.growthRecommendations;
            const queryRes = this.broker.extract(schemaResponse);
            // Undefined is not expected as a valid response from GraphQL
            if (queryRes === undefined) return reject(new (0, $37a46ca6bfe66fc8$export$ff264bfdc9a404eb)(response).makeQueryResult());
            return resolve(this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult());
        });
    }
    /**
   * Fetches the response by tha given request from the cache or the API
   * the cache config is optional, if not provided, the response will not be cached
   *
   * @param request The request to fetch the response from
   * @param cacheConfig The cache configuration to use
   * @returns The response from the request
   */ async getResponse(request, cacheConfig) {
        const cacheProvider = (0, $e5baf61a4d630ec7$export$2e2bcd8739ae039).resolve(cacheConfig);
        const cachedResponse = await cacheProvider.get(request);
        // If the response is cached, return it
        if (cachedResponse) return cachedResponse;
        // Clone the request before it being used to be able to use it multiple times
        const clonedRequest = request.clone();
        return fetch(request).then((response)=>{
            // Cache response only if the response is ok
            if (response.ok) cacheProvider.set(clonedRequest, response.clone());
            return response;
        });
    }
    constructor(broker){
        this.broker = broker;
    }
}


const $f225a3eb212dd10d$var$useRecommendations = ({ endpoint: endpoint = '/gateway/api/graphql', contextResolver: contextResolver })=>{
    /**
   * Fetch recommendations for a given context
   */ const getRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((args, deprecatedRerank = [])=>{
        // Deconstruct the args object with deprecated arguments to make it backwards compatible
        const { first: first, rerank: rerank, config: { cacheConfig: cacheConfig } = {
            cacheConfig: undefined
        } } = typeof args === 'number' ? {
            first: args,
            rerank: deprecatedRerank
        } : args;
        const recommendationRequestMaker = new (0, $33473eb0511f2f3c$export$2e2bcd8739ae039)(endpoint);
        const requester = new (0, $832d4de619bcc498$export$2e2bcd8739ae039)(new (0, $0dd1b01107e01178$export$7f19312509e0d2c0)());
        const context = (0, $c1e538033f9a5add$export$31553aaa555c1514)(contextResolver);
        return requester.fetch(recommendationRequestMaker.makeRequest({
            contextResolver: contextResolver,
            first: first,
            rerank: rerank
        }), {
            cacheConfig: cacheConfig ? {
                ...cacheConfig,
                cacheName: (0, $614c5c37063965fd$export$14b7e2c312f27acd),
                useCase: context.useCase
            } : undefined
        });
    }, [
        contextResolver,
        endpoint
    ]);
    return {
        getRecommendations: getRecommendations
    };
};
var $f225a3eb212dd10d$export$2e2bcd8739ae039 = $f225a3eb212dd10d$var$useRecommendations;


const $bcc0eb557c5a9fbe$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudgeFlags';
class $bcc0eb557c5a9fbe$export$f6f4711ce6617505 extends Error {
    constructor(message, options){
        super(message);
        this.options = void 0;
        this.name = 'RecommendationError';
        this.options = options;
    }
}
function $bcc0eb557c5a9fbe$export$e87e269d0f71e3a3({ product: product, sessionId: sessionId, cloudId: cloudId, subProduct: subProduct }) {
    const contextResolver = (0, $cozmU.useCallback)(()=>({
            product: product,
            useCase: $bcc0eb557c5a9fbe$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        product,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $f225a3eb212dd10d$export$2e2bcd8739ae039)({
        contextResolver: contextResolver
    });
    return (0, $cozmU.useCallback)(async ()=>{
        try {
            const result = await getRecommendations({
                first: 4,
                config: {
                    cacheConfig: {
                        ttl: 86400 // cache for 1 day in seconds
                    }
                }
            });
            const { response: { data: data } = {} } = result;
            const recommendedEntities = (data ?? []).map((e)=>e.entityId);
            return recommendedEntities;
        } catch (error) {
            let cause;
            if (error instanceof Error) cause = error;
            else if (error && error.reason) cause = new Error(error.reason);
            else cause = new Error(String(error));
            throw new $bcc0eb557c5a9fbe$export$f6f4711ce6617505('Get MSR nudge recommendations error', {
                cause: cause
            });
        }
    }, [
        getRecommendations
    ]);
}



var $dPJCf = parcelRequire("dPJCf");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");








var $biOtS = parcelRequire("biOtS");


var $hYAxW = parcelRequire("hYAxW");

const $3f1df2e5e7061ec6$export$57ede52633f7b520 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const customAnalytics = (0, $biOtS.getCustomExperimentAnalytics)('crossJoinNudges', createAnalyticsEvent);
    /**
   * Fire event only in case the event value has not been cached or cached value is different
   * to prevent excessive number of analytics calls.
   */ return (0, $cozmU.useCallback)(({ value: value, key: key })=>{
        try {
            const cachedValue = (0, $hYAxW.cjnLoomEventCacheController).get(key);
            if (!cachedValue || cachedValue.eligible !== value.eligible || cachedValue.ineligibilityReason !== value.ineligibilityReason) {
                (0, $biOtS.fireLoomCjnEligibilityChecked)(customAnalytics, {
                    ...value,
                    key: key
                });
                (0, $hYAxW.cjnLoomEventCacheController).set(key, value);
            }
        } catch (e) {
        // cache get fail, do nothing
        }
    }, [
        customAnalytics
    ]);
};




const $40e69e7df4e12fd0$export$b73ba4b3997f9abe = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireOnlyNewLoomEvent = (0, $3f1df2e5e7061ec6$export$57ede52633f7b520)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const getMSRNudgeRecommendations = (0, $bcc0eb557c5a9fbe$export$e87e269d0f71e3a3)({
        product: 'confluence',
        sessionId: (0, $9HkI0.v4)(),
        cloudId: cloudId,
        subProduct: ''
    });
    (0, $cozmU.useEffect)(()=>{
        const execCrossJoinNudge = async ()=>{
            if (userId) {
                const { checkLoomCrossJoinNudgeEligibility: checkLoomCrossJoinNudgeEligibility, showLoomCrossJoinNudge: showLoomCrossJoinNudge } = await (parcelRequire("dvzq9"));
                const isLoomCrossJoinNudgesEligible = await checkLoomCrossJoinNudgeEligibility({
                    cloudId: cloudId,
                    userId: userId,
                    createAnalyticsEvent: createAnalyticsEvent
                });
                if (isLoomCrossJoinNudgesEligible.eligible) {
                    await showLoomCrossJoinNudge({
                        cloudId: cloudId,
                        userId: userId,
                        flags: flags,
                        createAnalyticsEvent: createAnalyticsEvent,
                        formatMessage: formatMessage
                    });
                    return;
                }
                // Track eligibility failure reasons
                fireOnlyNewLoomEvent({
                    value: isLoomCrossJoinNudgesEligible,
                    key: 'cjn-conf-loom'
                });
            }
            const { checkJpdCrossJoinNudgeEligibility: checkJpdCrossJoinNudgeEligibility, showJpdCrossJoinNudge: showJpdCrossJoinNudge, triggerJiraCrossJoinNudge: triggerJiraCrossJoinNudge } = await Promise.resolve((parcelRequire("8AKrx")));
            const isJpdCrossJoinNudgesEligible = await checkJpdCrossJoinNudgeEligibility({
                cloudId: cloudId,
                userId: userId,
                createAnalyticsEvent: createAnalyticsEvent,
                getMSRNudgeRecommendations: getMSRNudgeRecommendations
            });
            if (isJpdCrossJoinNudgesEligible) await showJpdCrossJoinNudge({
                cloudId: cloudId,
                userId: userId,
                flags: flags,
                createAnalyticsEvent: createAnalyticsEvent,
                push: push
            });
            else await triggerJiraCrossJoinNudge({
                cloudId: cloudId,
                userId: userId,
                flags: flags,
                createAnalyticsEvent: createAnalyticsEvent,
                push: push,
                getMSRNudgeRecommendations: getMSRNudgeRecommendations
            });
        };
        execCrossJoinNudge();
    // Disabling as we only want this to execute based on `execCrossJoinNudge` or if `flags` gets updated.
    // This prevents edge cases where flags might be shown twice due to
    // Complex dependency arrays of children components/dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        flags
    ]);
};
const $40e69e7df4e12fd0$export$6e567f651a10d419 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    $40e69e7df4e12fd0$export$b73ba4b3997f9abe({
        flags: flags
    });
    return null;
});
module.exports["CrossJoinNudgesWithFlags"] = $40e69e7df4e12fd0$export$6e567f651a10d419;

});


//# sourceMappingURL=GlobalComponents.2f2e4115.js.map
